import whatInput from "what-input";
import lazySizes from "lazysizes";
import Flickity from "flickity";
// import apiFetch from '@wordpress/api-fetch';
import Cookies from "js-cookie";
var jQueryBridget = require("jquery-bridget");
Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);

lazySizes.cfg.expand = 300;
lazySizes.cfg.loadHidden = false;

(function ($) {
    var Tab = function (tabs_cont, options) {
        var _this = this;
        _this.args = $.extend(
            {
                class_nav: "tabs_nav",
                class_nav_item: "tabs_i",
            },
            options
        );
        _this.tabs_cont = tabs_cont;
        _this.panels = _this.tabs_cont.find(".js-tabs-section");
        if (!_this.panels.length) return;
        _this.tabs_items = $();
        _this.setNav();
        _this.tabs_links = _this.tabs_items.find("button");
        (_this.last_item = _this.tabs_items.last()),
            (_this.first_item = _this.tabs_items.first()),
            (_this.last_link = _this.last_item.find("button")),
            (_this.first_link = _this.first_item.find("button"));

        _this.init();
    };

    Tab.prototype = {
        setNav: function () {
            var _this = this;
            var tab_nav = $("<ul></ul>");
            tab_nav.addClass("js-tabs-nav").addClass(_this.args.class_nav);
            _this.panels.each(function (idx, el) {
                var panel_title = $(el).find(".js-tabs-title");
                var nav_item = $("<li></li>");
                nav_item
                    .addClass(_this.args.class_nav_item)
                    .html(
                        '<button data-panel="' +
                        el.getAttribute("id") +
                        '" type="button">' +
                        panel_title.html() +
                        "</button>"
                    );
                tab_nav.append(nav_item);
                panel_title.addClass("srOnly");
                _this.tabs_items = _this.tabs_items.add(nav_item);
            });
            _this.tabs_cont.prepend(tab_nav);
        },

        init: function () {
            var _this = this;

            //Attributs tablist
            _this.tabs_cont.attr("role", "tablist");

            //Attributs items
            _this.tabs_items.attr("role", "presentation");

            //Attributs liens
            _this.tabs_links.each(function (idx, el) {
                el.setAttribute("role", "tab");
                var idPanel = el.getAttribute("data-panel");
                if (typeof idPanel !== "undefined" && idPanel !== "") {
                    el.setAttribute("aria-controls", idPanel);
                    el.setAttribute("id", "label-" + idPanel);
                    el.setAttribute("tabindex", -1);
                    el.setAttribute("aria-selected", "false");
                }
                // el.removeAttribute('data-panel');
            });

            //Attributs panels
            _this.panels.each(function (idx, el) {
                var id = el.getAttribute("id");
                el.setAttribute("role", "tabpanel");
                el.setAttribute("aria-hidden", "true");
                el.setAttribute("aria-labelledby", "label-" + id);
            });

            //Events
            _this.tabs_links.on("click", function (event) {
                _this.clickOnTab(this, event);
            });
            _this.tabs_cont.on("keydown", function (event) {
                _this.keyOnTab(event);
            });

            //Class init
            _this.tabs_cont.addClass("js-tabs-init");

            // on sélectione le panel actif (ou le premier)
            var panel_index_to_select = 0;
            _this.panels.each(function (idx, el) {
                if ($(el).hasClass("to-open")) {
                    panel_index_to_select = idx;
                    // $(el).removeClass('to-open');
                }
            });
            if (panel_index_to_select !== false) {
                _this.tabs_links.eq(panel_index_to_select).trigger("click");
            }
        },

        resetAttr: function () {
            var _this = this;

            _this.tabs_links.attr("tabindex", "-1");
            _this.tabs_links.attr("aria-selected", "false");
            _this.panels.attr("aria-hidden", "true");
        },

        clickOnTab: function (link, event) {
            var _this = this;
            var target_id = link.getAttribute("aria-controls");
            var tab_linked = $("#" + target_id);
            if (link.getAttribute("aria-selected") == "true" || !tab_linked.length)
                return;
            _this.resetAttr();
            link.setAttribute("aria-selected", "true");
            link.setAttribute("tabindex", 0);
            tab_linked.removeAttr("aria-hidden");
            if (event) {
                event.preventDefault();
            }
            _this.tabs_cont.trigger("tabs:change", [
                _this,
                event.hasOwnProperty("originalEvent"),
                link,
                tab_linked.get(0),
            ]);
        },

        keyOnTab: function (event) {
            var _this = this;

            if (!event.ctrlKey) {
                var action = false;
                if (event.keyCode == 37 || event.keyCode == 38) {
                    // strike up or left in the tab
                    action = _this.prev();
                } else if (event.keyCode == 40 || event.keyCode == 39) {
                    // strike down or right in the tab
                    action = _this.next();
                } else if (event.keyCode == 36) {
                    // activate first tab
                    action = _this.goToFirst();
                } else if (event.keyCode == 35) {
                    // activate last tab
                    action = _this.goToLast();
                }

                if (action && event) {
                    event.preventDefault();
                }
            }
        },

        getActiveItem: function () {
            var _this = this;
            var activated = false;
            _this.tabs_links.each(function (idx, el) {
                if (
                    !activated &&
                    el.hasAttribute("aria-selected") &&
                    el.getAttribute("aria-selected") == "true"
                )
                    activated = el.parentNode;
            });
            return activated;
        },

        prev: function (noFocus) {
            var _this = this;

            var activated = _this.getActiveItem();
            var linkToClick = false;
            if (activated) {
                if (activated === _this.first_item.get(0)) {
                    linkToClick = _this.last_link.get(0);
                } else {
                    linkToClick = activated.previousElementSibling.children[0];
                }
            }
            if (linkToClick) {
                $(linkToClick).trigger("click");
                if (!noFocus) {
                    $(linkToClick).focus();
                }
            }
            return linkToClick;
        },

        next: function (noFocus) {
            var _this = this;

            var activated = _this.getActiveItem();
            var linkToClick = false;
            if (activated) {
                if (activated === _this.last_item.get(0)) {
                    linkToClick = _this.first_link.get(0);
                } else {
                    linkToClick = activated.nextElementSibling.children[0];
                }
            }
            if (linkToClick) {
                $(linkToClick).trigger("click");
                if (!noFocus) {
                    $(linkToClick).focus();
                }
            }
            return linkToClick;
        },

        goTo: function (idx, noFocus) {
            var _this = this;
            var $linkToClick = _this.tabs_items.eq(idx).find("button");
            $linkToClick.trigger("click");
            if (!noFocus) {
                $linkToClick.focus();
            }
            return $linkToClick.get(0);
        },

        goToFirst: function () {
            var _this = this;
            return _this.goTo(0);
        },

        goToLast: function () {
            var _this = this;
            return _this.goTo(_this.tabs_links.length - 1);
        },

        destroy: function () {
            var _this = this;
            _this.tabs_cont.find(".js-tabs-title").removeClass("srOnly");
            _this.tabs_cont.find(".js-tabs-nav").remove();
            _this.tabs_cont.removeAttr("role");
            _this.tabs_items.removeAttr("role");
            _this.tabs_links
                .removeAttr("role")
                .removeAttr("aria-controls")
                .removeAttr("id")
                .removeAttr("tabindex")
                .removeAttr("aria-selected");
            _this.panels
                .removeAttr("role")
                .removeAttr("aria-hidden")
                .removeAttr("aria-labelledby");
            _this.tabs_cont.removeClass("js-tabs-init");
            _this.tabs_cont.off("keydown");
        },
    };

    $.fn.tabs = function (options) {
        var settings = $.extend(
            {
                class_nav: "tabs_nav",
                class_nav_item: "tabs_i",
            },
            options
        );
        var tabs = [];
        if (this.length) {
            this.each(function (idx, el) {
                tabs.push(new Tab($(el), settings));
            });
        }
        return tabs;
    };

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Variables
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var w = window,
        d = document,
        $window = $(w),
        $html = $("html"),
        $body = $("body"),
        $header = $("#header"),
        $nav = $("#nav"),
        $main = $("#main"),
        $pageNav_inner = $(".pageNav_inner"),
        $stickyBars = $main.find(".stickyBar"),
        headerH,
        windowH,
        windowW,
        scrollT,
        scrollUp = false,
        $adminBar = $("#wpadminbar"),
        has_adminBar = $body.hasClass("admin-bar"),
        adminBar_h = 0,
        serveur_test = d.location.hostname == "localhost",
        is_requeting = false,
        is_menu_mobile = false,
        $triggerMobile = $("#menuTrigger"),
        sauvScroll = 0,
        vhCssVar = false;

    $html.addClass("is-js-init");

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Dimensions
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function update_dimensions() {
        windowH = window.innerHeight;
        windowW = $window.width();
        headerH = $header.length ? $header.outerHeight() : 0;
        var old_is_menu_mobile = is_menu_mobile;
        is_menu_mobile = $triggerMobile.is(":visible");
        if (old_is_menu_mobile != is_menu_mobile) {
            menu_mobile_change(old_is_menu_mobile, is_menu_mobile);
        }
        update_adminbar();
        update_scroll();
    }
    update_dimensions();

    function update_scroll() {
        if ($window.scrollTop() < scrollT) {
            scrollUp = true;
        } else {
            scrollUp = false;
        }
        scrollT = $window.scrollTop();
    }

    function update_adminbar() {
        adminBar_h =
            parseInt($html.css("margin-top")) + parseInt($body.css("margin-top"));
    }

    function menu_mobile_change(o, n) {
        remove_focus_trap_aria_hidden();
        if (!o && n) {
            accs_build();
        } else if (o && !n) {
            accs_mobile_reset();
        }
    }

    function setCssVarVH() {
        if (!vhCssVar || Math.abs(vhCssVar - windowH) > 250) {
            vhCssVar = windowH;
            document.documentElement.style.setProperty("--vh", windowH + "px");
        }
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Helper functions
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // Récupère les variables d'une url
    function getQueryVariables(url) {
        var query = url.split("?");
        var vars = (query.length > 1 ? query[1] : "").split("&");
        var returnVars = {};
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            returnVars[pair[0]] = pair[1] ? pair[1] : null;
        }
        return returnVars;
    }

    //Debounce
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    //Load js async
    function async(script, callback) {
        var s = document.createElement("script"),
            head = document.getElementsByTagName("head")[0];
        s.type = "text/javascript";
        s.async = true;
        s.defer = true;
        s.src = script;
        if (typeof callback == "function") {
            s.addEventListener(
                "load",
                function (e) {
                    callback.call();
                },
                false
            );
        }
        head.appendChild(s);
    }

    //Load css
    function loadCSS(href, callback, media) {
        var doc = w.document;
        var ss = doc.createElement("link");
        var ref;
        var refs = (doc.body || doc.getElementsByTagName("head")[0]).childNodes;
        ref = refs[refs.length - 1];
        var sheets = doc.styleSheets;
        ss.rel = "stylesheet";
        ss.href = href;
        ss.media = "only x";
        ref.parentNode.insertBefore(ss, ref.nextSibling);
        var onloadcssdefined = function (cb) {
            var resolvedHref = ss.href;
            var i = sheets.length;
            while (i--) {
                if (sheets[i].href === resolvedHref) {
                    return cb();
                }
            }
            setTimeout(function () {
                onloadcssdefined(cb);
            });
        };
        function loadCB() {
            if (ss.addEventListener) {
                ss.removeEventListener("load", loadCB);
            }
            ss.media = media || "all";
            if (typeof callback == "function") {
                callback();
            }
        }
        if (ss.addEventListener) {
            ss.addEventListener("load", loadCB);
        }
        ss.onloadcssdefined = onloadcssdefined;
        onloadcssdefined(loadCB);
    }

    //pad number
    function pad(number) {
        if (number < 10) {
            return "0" + number;
        }
        return number;
    }

    // normalize a text
    function normalizeText(text) {
        return text
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s]|_/g, "")
            .replace(/\s+/g, "");
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Scroll jusqu'a un element
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function scrollToEl($el, marge, cb) {
        var offsetEl = 0;
        if (marge) {
            offsetEl -= marge;
        }
        if ($el.length) {
            offsetEl += $el.offset().top - adminBar_h;
            offsetEl += 2;
            var elMargin = parseInt($el.css("marginTop"));
            var elPadding = parseInt($el.css("paddingTop"));
            if (!elPadding && elMargin) {
                offsetEl -= elMargin;
            } else if (!elPadding) {
                elMargin = parseInt($el.prev().css("marginBottom"));
                elPadding = parseInt($el.prev().css("paddingBottom"));
                if (elPadding) {
                    offsetEl -= elPadding;
                } else if (elMargin) {
                    offsetEl -= elMargin;
                }
            }
        }
        // Menu masqué qui va slide down
        // if(offsetEl < scrollT && offsetEl > 2 * headerH) {
        //   offsetEl -= $header.outerHeight();
        // }
        scrollToOffset(offsetEl, cb || undefined);
    }

    function scrollToOffset(offsetEl, cb) {
        $("html, body").animate(
            {
                scrollTop: offsetEl,
            },
            300,
            cb || undefined
        );
    }

    function scroller_init($cont) {
        $cont = $cont && $cont.length ? $cont : $body;
        var $directElToScroll = $cont.find(".js-scroll-to-me").first();
        if ($directElToScroll.length) scrollToEl($directElToScroll);
    }
    scroller_init();

    $body.on("click", 'a.js-scroller[href^="#"]', function (event) {
        if (whatInput.ask() === "keyboard") return;
        var $this = $(this);
        var $target = $($this.attr("href"));
        if ($target.length && $this.attr("data-scroll-parent")) {
            $target = $target.closest($this.attr("data-scroll-parent"));
        }
        if ($target.length) {
            event.preventDefault();
            if ($this.get(0).hasAttribute("data-scroll-focus")) {
                scrollToEl($target, 0, function () {
                    $target.find('input, textarea, select').first().focus();
                });
            } else {
                scrollToEl($target);
            }
        }
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Supports
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function test_history() {
        var ua = navigator.userAgent;
        if (
            (ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) &&
            ua.indexOf("Mobile Safari") !== -1 &&
            ua.indexOf("Chrome") === -1 &&
            ua.indexOf("Windows Phone") === -1 &&
            location.protocol !== "file:"
        ) {
            return false;
        }
        // if(ua.match(/((iPod|iPhone|iPad).+\bOS\s+[1-4]|WebApps\/.+CFNetwork)/)) {
        // 	return false;
        // }
        return (
            window.history &&
            "pushState" in window.history &&
            "replaceState" in window.history
        );
    }

    var transformProp;
    (function () {
        var style = document.createElement("a").style;
        var prop;
        if (style[(prop = "webkitTransform")] !== undefined) {
            transformProp = prop;
        }
        if (style[(prop = "msTransform")] !== undefined) {
            transformProp = prop;
        }
        if (style[(prop = "transform")] !== undefined) {
            transformProp = prop;
        }
    })();

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Focus trap
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var $lastFocusedElement = false;
    var is_focus_traped = false;

    function set_focus_trap($cont) {
        if (!$cont || !$cont.length) return;
        $lastFocusedElement = $(document.activeElement);
        update_content_focus_trap($cont);
        set_focus_trap_aria_hidden($cont);
        is_focus_traped = true;
    }

    function update_content_focus_trap($cont) {
        if (!$cont || !$cont.length) return;
        var $focusableElements = $cont
            .find(
                "a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])"
            )
            .not('[tabindex="-1"]');
        var $firstTabStop = $focusableElements.first();
        var $lastTabStop = $focusableElements.last();
        $firstTabStop.focus();
        $cont.off("keydown").on("keydown", function (event) {
            if (event.keyCode === 9) {
                //Tab
                if (event.shiftKey) {
                    //Shift + Tab
                    if (document.activeElement === $firstTabStop.get(0)) {
                        event.preventDefault();
                        $lastTabStop.focus();
                    }
                } else {
                    //just Tab
                    if (document.activeElement === $lastTabStop.get(0)) {
                        event.preventDefault();
                        $firstTabStop.focus();
                    }
                }
            }
        });
    }

    function remove_focus_trap($cont) {
        if (!$cont || !$cont.length) return;
        $cont.off("keydown");
        remove_focus_trap_aria_hidden();
        if ($lastFocusedElement && $lastFocusedElement.length) {
            $lastFocusedElement.focus();
        }
        is_focus_traped = false;
    }

    function set_focus_trap_aria_hidden($el) {
        $el
            .siblings(":not(script):not(link):not([aria-hidden])")
            .attr("aria-hidden", "true")
            .addClass("is-hidden-by-focus-trap");
        // if($el.is('.nav')) {
        //   $el.closest('.header').siblings(':not(script):not(link):not([aria-hidden])').not('.toolbar').attr('aria-hidden', 'true').addClass('is-hidden-by-focus-trap');
        //   $('#toolbar').find('.toolbar_navi:not(.toolbar_navi-navmobile)').attr('aria-hidden', 'true').addClass('is-hidden-by-focus-trap');
        // }
    }

    function remove_focus_trap_aria_hidden() {
        $body
            .find(".is-hidden-by-focus-trap")
            .removeAttr("aria-hidden")
            .removeClass("is-hidden-by-focus-trap");
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Menu
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var $nav_links = $header.find(".nav_i > a");
    var $nav_items = $header.find(".nav_i");

    menu_set_a11y();
    $nav_links.on("click", trigger_nav_link);

    function trigger_nav_link(event) {
        var $this = $(this);
        var $link_item = $this.closest(".nav_i");
        var $sub_menu = $link_item.find(".nav_sub");
        if (!$sub_menu.length) {
            closeSubMenu(true);
            return;
        }
        event.preventDefault();
        if ($link_item.hasClass("is-open")) {
            $link_item.removeClass("is-open");
            $html.removeClass("has-subnavOpen");
            // if(!is_menu_mobile) {
            //   window.scrollTo(0, sauvScroll);
            // }
            // remove_focus_trap($sub_menu);
        } else {
            if (!$html.hasClass("has-subnavOpen")) {
                // if(!is_menu_mobile) {
                //   sauvScroll = scrollT;
                // }
            } else {
                $nav_items.removeClass("is-open");
            }
            $link_item.addClass("is-open");
            $html.addClass("has-subnavOpen");
            // set_focus_trap($sub_menu);
            $sub_menu.find("input").focus();
        }
        menu_update_a11y();
    }

    function closeSubMenu(resetTrap) {
        if ($html.hasClass("has-subnavOpen")) {
            // if(resetTrap) {
            //   remove_focus_trap($nav_items.filter('.is-open').find('.nav_sub'));
            // }
            $html.removeClass("has-subnavOpen");
            $nav_items.removeClass("is-open");
            // if(!is_menu_mobile) {
            //   window.scrollTo(0, sauvScroll);
            // }
            menu_update_a11y();
        }
    }

    function menu_set_a11y() {
        $nav.find(".nav_wrapper").attr({
            role: "menubar",
            "aria-label": "Menu principal",
        });
        $header.find(".header_nav-2 .nav_wrapper").attr({
            role: "menubar",
            "aria-label": "Menu secondaire",
        });
        $nav_links.each(function (idx, el) {
            var $el = $(el);
            $el
                .attr("role", "menuitem")
                .filter(":not(:last-child)")
                .attr({
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                    "aria-controls": "menu-item-" + (idx + 1),
                })
                .next(".nav_sub")
                .attr({
                    "aria-hidden": "true",
                    id: "menu-item-" + (idx + 1),
                })
                .find("ul")
                .attr("role", "menu")
                .find("li")
                .attr("role", "none")
                .children("a")
                .attr("role", "menuitem");
        });
        $nav_items.attr("role", "none");
    }

    function menu_update_a11y() {
        $nav_links
            .filter(":not(:last-child)")
            .closest(".nav_i")
            .each(function (index, el) {
                var $el = $(el);
                if ($(el).hasClass("is-open")) {
                    $el
                        .children("a")
                        .attr("aria-expanded", "true")
                        .next(".nav_sub")
                        .attr("aria-hidden", "false");
                } else {
                    $el
                        .children("a")
                        .attr("aria-expanded", "false")
                        .next(".nav_sub")
                        .attr("aria-hidden", "true");
                }
            });
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Menu mobile
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var idMenuMobileTimeOut = false;
    $triggerMobile.on("click", function (event) {
        event.preventDefault();
        menu_mobile_toggle();
    });

    function menu_mobile_toggle() {
        if ($html.hasClass("has-menuMobileOpen")) {
            menu_mobile_close();
        } else {
            menu_mobile_open();
        }
    }

    function menu_mobile_open() {
        if (!$html.hasClass("is-scrollBlockedMobile")) {
            sauvScroll = scrollT;
            w.scrollTo(0, 0);
            idMenuMobileTimeOut = w.setTimeout(function () {
                $html.addClass("is-scrollBlockedMobile");
            }, 300);
        }
        $html.addClass("has-menuMobileOpen");
        if ($html.hasClass("has-submenuMobileOpen")) {
            $header.find('.nav-2 .nav_i > a[aria-expanded="true"]').trigger("click");
        }
    }

    function menu_mobile_close() {
        if (idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
        $html.removeClass("is-scrollBlockedMobile");
        // closeSubMenu();
        w.scrollTo(0, sauvScroll);
        w.setTimeout(function () {
            $html.removeClass("has-menuMobileOpen");
        }, 50);
    }

    $header
        .find(".nav-2 .nav_i > a:not(:last-child)")
        .on("click", function (event) {
            if ($(this).is('[aria-expanded="true"]')) {
                if ($html.hasClass("has-menuMobileOpen")) {
                    $html.removeClass("has-menuMobileOpen");
                }
                if (!$html.hasClass("is-scrollBlockedMobile")) {
                    sauvScroll = scrollT;
                    if (is_menu_mobile) {
                        w.scrollTo(0, 0);
                    }
                    idMenuMobileTimeOut = w.setTimeout(function () {
                        $html.addClass("is-scrollBlockedMobile");
                    }, 300);
                }
                $html.addClass("has-submenuMobileOpen");
            } else {
                if (
                    $html.hasClass("is-scrollBlockedMobile") &&
                    !$html.hasClass("has-menuMobileOpen")
                ) {
                    if (idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
                    $html.removeClass("is-scrollBlockedMobile");
                    if (is_menu_mobile) {
                        w.scrollTo(0, sauvScroll);
                    }
                }
                $html.removeClass("has-submenuMobileOpen");
            }
        });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Accordéons
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function accs_init($cont) {
        $cont = $cont && $cont.length ? $cont : $main;
        $cont.find(".acc:not(.js-acc)").addClass("js-acc");
        // $cont
        //   .find('.matiere_section:not(.js-acc)')
        //   .addClass('js-acc')
        //   .addClass('js-acc-mobile');
        accs_build($cont);
    }
    accs_init();

    function accs_build($cont) {
        $cont = $cont && $cont.length ? $cont : $main;
        $cont.find(".js-acc:not(.is-init)").each(function (idx, el) {
            acc_build(el);
        });
    }

    function acc_build(el, idAcc) {
        var $wrapper = $(el);
        var $head = $wrapper.children(":nth-last-child(2)");
        var $cont = $wrapper.children(":nth-last-child(1)");
        idAcc =
            idAcc ||
            Math.floor(Math.random() * (1000 + 1)) +
            1000 +
            "" +
            (Math.floor(Math.random() * (1000 + 1)) + 1000) +
            "" +
            (Math.floor(Math.random() * (1000 + 1)) + 1000) +
            "";
        if (
            !$head.length ||
            !$cont.length ||
            (!is_menu_mobile && $wrapper.hasClass("js-acc-mobile"))
        )
            return;
        $head
            .addClass("js-acc-head")
            .wrapInner(
                '<button type="button" aria-expanded="false" aria-controls="acc-id-' +
                idAcc +
                '" id="acc-title-id-' +
                idAcc +
                '"></button>'
            );
        $wrapper.addClass("is-init").addClass("is-closed");
        $cont
            .addClass("js-acc-content")
            .hide()
            .attr("id", "acc-id-" + idAcc)
            .attr("aria-labelledby", "acc-title-id-" + idAcc)
            .attr("aria-hidden", "true");
        $head.on("click", "button", function (event) {
            event.preventDefault();
            $cont.slideToggle(400);
            if ($wrapper.hasClass("is-closed")) {
                $wrapper.removeClass("is-closed");
                $head.find("[aria-expanded]").attr("aria-expanded", "true");
                $cont.attr("aria-hidden", "false");
            } else {
                $wrapper.addClass("is-closed");
                $head.find("[aria-expanded]").attr("aria-expanded", "false");
                $cont.attr("aria-hidden", "true");
            }
        });
    }

    function acc_direct_open($acc) {
        if (!$acc.hasClass("is-closed")) return;
        $acc
            .removeClass("is-closed")
            .find(".js-acc-content")
            .removeAttr("style")
            .attr("aria-hidden", "false");
        $acc.find(".js-acc-head [aria-expanded]").attr("aria-expanded", "true");
    }

    function accs_mobile_reset($cont) {
        $cont = $cont && $cont.length ? $cont : $main;
        if (is_menu_mobile) return;
        $cont.find(".js-acc-mobile.is-init").each(function (idx, el) {
            acc_reset(el);
        });
    }

    function acc_reset(el) {
        var $wrapper = $(el);
        var $head = $wrapper.children(":nth-last-child(2)");
        var $cont = $wrapper.children(":nth-child(2)");
        $wrapper.removeClass("is-init").removeClass("is-closed");
        $head
            .removeClass("js-acc-head")
            .off("click", "button")
            .find("button")
            .contents()
            .unwrap();
        $cont
            .removeClass("js-acc-content")
            .removeAttr("id")
            .removeAttr("style")
            .removeAttr("aria-labelledby")
            .removeAttr("aria-hidden");
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Scroll et ouverture accordéon initial
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    if (location.hash) {
        var locationHash = location.hash.replace("#", "");
        var $scrollTarget = $main.find('[data-target-id="' + locationHash + '"]');
        if (!$("#" + locationHash).length && $scrollTarget.length) {
            scrollToEl($scrollTarget);
            if ($scrollTarget.is(".js-acc.is-init.is-closed")) {
                $scrollTarget.find(".js-acc-head button").trigger("click");
            }
        }
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Menu qui se masque
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // function auto_hide_header() {
    //   if(is_menu_mobile) {
    //     return;
    //   }
    //   if(scrollUp && scrollT > 2 * headerH) {
    //     $html.removeClass('is-nav-hide');
    //   } else {
    //     $html.addClass('is-nav-hide');
    //   }
    // }
    // auto_hide_header();

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Grille
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // function grid_init($cont,$grids) {
    //   $cont = $cont && $cont.length ? $cont : $main;
    //   $grids = $grids && $grids.length ? $grids : $cont.find('.js-grid');
    //   if(!$grids.length) return;
    //
    //   $grids.each(function(idx, el) {
    //     $(el).addClass('is-init');
    //     var $childs = $(el).children(':not(.is-hide)');
    //     ffgrid({
    //       cont: el,
    //       item: $childs.toArray(),
    //       cols: el.hasAttribute('data-nb-cols') ? parseInt(el.getAttribute('data-nb-cols')) : false,
    //       gutterW: parseFloat($childs.first().css('margin-right')),
    //       gutterH: parseFloat($childs.first().css('margin-bottom')),
    //       variableW: el.hasAttribute('data-variable-width'),
    //     });
    //   });
    // }
    // grid_init();

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Modales
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // $body.find('.js-modal').appendTo($body);
    // $body.find('[data-modal]').on('click', function(event) {
    //   event.preventDefault();
    //   var $target = $('#'+$(this).attr('data-modal'));
    //   if($target.length) {
    //     $target.removeClass('is-hide').attr('aria-hidden', 'false');
    //     $html.addClass('has-modal');
    //     set_focus_trap($target);
    //   }
    // });
    // $body.find('.js-modal-close').on('click', function(event) {
    //   event.preventDefault();
    //   modale_close(this);
    // });
    //
    // function modale_close(target) {
    //   if($html.hasClass('has-modal')) {
    //     if(target) {
    //       remove_focus_trap($(target).closest('.js-modal'));
    //       $(target).closest('.js-modal').addClass('is-hide').attr('aria-hidden', 'true');
    //     } else {
    //       remove_focus_trap($body.find('.js-modal:not(.is-hide)'));
    //       $body.find('.js-modal:not(.is-hide)').addClass('is-hide').attr('aria-hidden', 'true');
    //     }
    //     $html.removeClass('has-modal');
    //   }
    // }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Select2
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // var select2_is_ready = false;
    // var select2_js_is_ready = false;
    // var select2_css_is_ready = false;
    // var select2_js_is_loading = false;
    // var select2_css_is_loading = false;
    //
    // function init_selects() {
    //   var $selects = $body.find('.js-select');
    //   if(is_menu_mobile || !$selects.length) return;
    //   selects_load_select2();
    // }
    // init_selects();
    //
    // function selects_destroy() {
    //   if ($.fn.select2) {
    //     $body.find('.js-select.select2-hidden-accessible').select2('destroy');
    //   }
    // }
    //
    // function selects_load_select2() {
    //   if(select2_is_ready) {
    //     init_select2_on_selects();
    //     return;
    //   }
    //   if(!select2_js_is_loading) {
    //     select2_js_is_loading = true;
    //     async(url.theme+'js/vendor/select2.min.js', select2_js_loaded);
    //   }
    //   if(!select2_css_is_loading) {
    //     select2_css_is_loading = true;
    //     loadCSS(url.theme+'js/vendor/select2.min.css', select2_css_loaded, $('head').find('link[rel="stylesheet"]').get(0));
    //   }
    // }
    //
    // function select2_js_loaded() {
    //   select2_js_is_ready = true;
    //   check_select2_is_ready();
    // }
    //
    // function select2_css_loaded() {
    //   select2_css_is_ready = true;
    //   check_select2_is_ready();
    // }
    //
    // function check_select2_is_ready() {
    //   if(!select2_is_ready && select2_js_is_ready && select2_css_is_ready) {
    //     select2_is_ready = true;
    //     init_select2_on_selects();
    //   }
    //   return select2_is_ready;
    // }
    //
    // function init_select2_on_selects() {
    //   $body.find('.js-select').each(function(index, el) {
    //     $(el).select2({
    //       dropdownAutoWidth: false,
    //       width: 'resolve',
    //       dropdownParent: !el.hasAttribute('data-no-append') ? $(el).parent() : false,
    //       minimumResultsForSearch: Infinity,
    //       theme: el.hasAttribute('data-theme') ? el.getAttribute('data-theme') : 'alisfa',
    //       dropdownPosition: 'below'
    //       // placeholder
    //     });
    //     $(el).on('select2:open',function(e){
    //       setTimeout(function(){
    //         $(el).resize();
    //       },10);
    //     });
    //   });
    // }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Datepicker (http://t1m0n.name/air-datepicker/docs/)
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // var datepicker_is_ready = false;
    // var datepicker_js_is_ready = false;
    // var datepicker_css_is_ready = false;
    // var datepicker_js_is_loading = false;
    // var datepicker_css_is_loading = false;
    //
    // function init_datepickers() {
    //   var $datepickers = $body.find('.js-datepicker');
    //   if(!$datepickers.length) return;
    //   selects_load_datepicker();
    // }
    // init_datepickers();
    //
    // function selects_load_datepicker() {
    //   if(datepicker_is_ready) {
    //     init_datepicker_on_datepickers();
    //     return;
    //   }
    //   if(!datepicker_js_is_loading) {
    //     datepicker_js_is_loading = true;
    //     async(url.theme+'js/vendor/datepicker.min.js', datepicker_js_loaded);
    //   }
    //   if(!datepicker_css_is_loading) {
    //     datepicker_css_is_loading = true;
    //     loadCSS(url.theme+'js/vendor/datepicker.min.css', datepicker_css_loaded, $('head').find('link[rel="stylesheet"]').get(0));
    //   }
    // }
    //
    // function datepicker_js_loaded() {
    //   datepicker_js_is_ready = true;
    //   check_datepicker_is_ready();
    // }
    //
    // function datepicker_css_loaded() {
    //   datepicker_css_is_ready = true;
    //   check_datepicker_is_ready();
    // }
    //
    // function check_datepicker_is_ready() {
    //   if(!datepicker_is_ready && datepicker_js_is_ready && datepicker_css_is_ready) {
    //     datepicker_is_ready = true;
    //     init_datepicker_on_datepickers();
    //   }
    //   return datepicker_is_ready;
    // }
    //
    // function init_datepicker_on_datepickers() {
    //   $body.find('.js-datepicker').each(function(index, el) {
    //     datepicker_set(el);
    //   });
    // }
    //
    // function datepicker_set(input) {
    //   var $input = $(input);
    //   var $inputAlt = $input.parent().find('input.js-datepicker-alt');
    //   var datepicker = $input.datepicker({
    //     language: { //https://github.com/t1m0n/air-datepicker/tree/master/dist/js/i18n
    //       // days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'], //pas utilisé
    //       // daysShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'], //pas utilisé
    //       daysMin: str.days_letter,
    //       months: str.months,
    //       monthsShort: str.months_short,
    //       // today: "Aujourd’hui", //pas utilisé
    //       // clear: 'Effacer', //pas utilisé
    //       dateFormat: str.dateformat,
    //       // timeFormat: 'hh:ii', //pas utilisé
    //       firstDay: parseInt(str.first_day_week)
    //     },
    //     showOtherMonths: false,
    //     selectOtherMonths: false,
    //     autoClose: true,
    //     navTitles: {
    //       days: str.datepicker_navtitles,
    //     },
    //     altField: $inputAlt,
    //     altFieldDateFormat: 'yyyy/mm/dd',
    //     minDate: new Date(),
    //     position: 'bottom right',
    //     offset: 0,
    //     range: true,
    //     multipleDatesSeparator: ' - ',
    //     toggleSelected: false,
    //     prevHtml: '<span class="icon-carret_left"></span>',
    //     nextHtml: '<span class="icon-carret_right"></span>',
    //     onShow: function(inst, animationCompleted) {
    //       $input.closest('.calendar').addClass('has-calendar-open');
    //       setTimeout(function(){
    //         datepicker.update('position');
    //       },5);
    //     },
    //     onHide: function(inst, animationCompleted) {
    //       $input.closest('.calendar').removeClass('has-calendar-open');
    //     },
    //     onSelect: function(formattedDate, date, inst) {
    //       if($input.hasClass('is-datapicker-init') && (!date || date.length && date.length >= 1)) {
    //         var $parent = inst && inst.el ? $(inst.el).closest('[data-filters]') : [];
    //         if(date.length && date.length >= 1 && $('#filter-select-type_activite').length && $('#filter-select-type_activite').val() == '-1') {
    //           $('#filter-select-type_activite').val('').trigger('change');
    //         } else if($parent && $parent.length) { //si trigger change précédent ça update déjà
    //           filters_update($parent,'datepicker');
    //         }
    //       }
    //       if(date && date.length && date.length >= 1) {
    //         $input.closest('.calendar').addClass('has-calendar-value');
    //       } else {
    //         $input.closest('.calendar').removeClass('has-calendar-value');
    //       }
    //       if($input.val() && $input.val() != '') {
    //         $input.closest('.calendar').addClass('has-calendar-value');
    //       } else {
    //         $input.closest('.calendar').removeClass('has-calendar-value');
    //       }
    //       var dateDisplay = $input.val();
    //       if ( date.length && date.length >= 2 && ''+date[0].getFullYear()+pad(date[0].getMonth()+1)+pad(date[0].getDate()) == ''+date[1].getFullYear()+pad(date[1].getMonth()+1)+pad(date[1].getDate()) ) {
    //         dateDisplay = dateDisplay.split(' - ')[0];
    //       }
    //       $input.closest('.calendar').find('.calendar_choosen').html(dateDisplay);
    //     },
    //     onRenderCell: function(date, cellType) {
    //       if (cellType == 'day') {
    //         var intDate = date ? parseInt(''+date.getFullYear()+pad(date.getMonth()+1)+pad(date.getDate())) : false;
    //         if(intDate && dates_activites.indexOf(intDate) !== -1) {
    //           return {
    //             // html: '',
    //             classes: 'has-activites',
    //             // disabled: true
    //           }
    //         }
    //       }
    //     }
    //   }).data('datepicker');
    //
    //   $input.parent().find('.js-datepicker-reset').on('click', function(event) {
    //     event.preventDefault();
    //     datepicker.clear();
    //   });
    //
    //   if($inputAlt.val() && $inputAlt.val() != '') {
    //     var arrayDates = $inputAlt.val().replace(/[^0-9-]/g, "").split('-');
    //     arrayDates = arrayDates.map(function(v) {
    //       if(v.length == 8) {
    //         return [parseInt(v.substring(0,4)),parseInt(v.substring(4,6)),parseInt(v.substring(6,8))];
    //       } else {
    //         return false;
    //       }
    //     }).filter(function(v) {
    //       return v && v.length == 3 && v[2] <= 31 && v[2] >= 1 && v[1] <= 12 && v[1] >= 1 && v[0] <= 3000 && v[0] >= 1900;
    //     }).map(function(v) {
    //       return new Date(v[0],v[1] - 1,v[2],23,59,59,999);
    //     }).filter(function(v) {
    //       return v >= new Date();
    //     }).slice(0,2);
    //     if(arrayDates.length) {
    //       datepicker.selectDate(arrayDates);
    //     } else {
    //       $inputAlt.val('');
    //     }
    //   }
    //   $input.addClass('is-datapicker-init');
    // }
    //
    // function datepicker_update_dates($parent,dates) {
    //   var datepicker = $parent.find('.js-datepicker').first().data('datepicker');
    //   if(datepicker)
    //     datepicker.update();
    // }
    //
    // function datepicker_clear_dates($parent) {
    //   var datepicker = $parent.find('.js-datepicker').first().data('datepicker');
    //   if(datepicker)
    //     datepicker.clear();
    // }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Slider
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // $('.slider').each(function(index, el) {
    //   $(el).on('slider:destroy', function(event) {
    //     slider_destroy(this)
    //   }).on('slider:construct', function(event) {
    //     slider_construct(this);
    //   }).trigger('slider:construct').on('focus', '.slider_i a', slider_focus_on_slide);
    // });
    //
    // function slider_construct(el) {
    //   new Flickity(el,{
    //     cellAlign: 'left',
    //     wrapAround: false,
    //     // lazyLoad: 2, //data-flickity-lazyload-srcset & data-flickity-lazyload-src
    //     pageDots: $(el).find('.slider_i').length > 1,
    //     groupCells: false,
    //     contain: true,
    //     adaptiveHeight: false,
    //     setGallerySize: false,
    //     resize: false,
    //     prevNextButtons: false,
    //   });
    // }

    // function slider_destroy(el) {
    //   var flkty = Flickity.data( el );
    //   flkty.destroy();
    // }

    // function slider_focus_on_slide(event) {
    //   var $slide = $(this).closest('.slider_i');
    //   var $slider = $slide.closest('.slider');
    //   if(!$slider.hasClass('flickity-enabled')) return;
    //   var flkty = Flickity.data( $slider.get(0) );
    //   flkty.selectCell($slide.index());
    // }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Plyr
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var plyr_is_ready = false;
    var plyr_js_is_ready = false;
    var plyr_css_is_ready = false;
    var plyr_js_is_loading = false;
    var plyr_css_is_loading = false;
    var $videosIframes = [];
    $main
        .find(".media.is-type-video iframe[src]")
        .wrap('<div class="js-plyr"></div>');
    $main.find(".media.is-type-video video").addClass("js-plyr");

    function init_videos() {
        if (!$videosIframes.length) return;
        video_load_plyr();
    }

    function reinit_videos() {
        $videosIframes = $main.find(".js-plyr");
        init_videos();
    }
    reinit_videos();

    function video_load_plyr() {
        if (plyr_is_ready) {
            init_plyr_on_video();
            return;
        }

        if (!plyr_js_is_loading) {
            plyr_js_is_loading = true;
            async(url.theme + "lib/plyr.min.js", plyr_js_loaded);
        }
        if (!plyr_css_is_loading) {
            plyr_css_is_loading = true;
            loadCSS(url.theme + "lib/plyr.min.css", plyr_css_loaded);
        }
    }

    function plyr_js_loaded() {
        plyr_js_is_ready = true;
        check_plyr_is_ready();
    }

    function plyr_css_loaded() {
        plyr_css_is_ready = true;
        check_plyr_is_ready();
    }

    function check_plyr_is_ready() {
        if (!plyr_is_ready && plyr_js_is_ready && plyr_css_is_ready) {
            plyr_is_ready = true;
            init_plyr_on_video();
        }
        return plyr_is_ready;
    }

    function init_plyr_on_video() {
        // https://github.com/sampotts/plyr
        var players = Plyr.setup("#main .js-plyr", {
            vimeo: {
                controls: false,
            },
            fullscreen: {
                enabled: true,
                fallback: true,
                iosNative: true,
                container: null,
            },
            controls: [
                "play",
                "progress",
                "current-time",
                "mute",
                "volume",
                "fullscreen",
                "play-large",
            ],
        });
    }

    d.addEventListener("lazybeforeunveil", function (e) {
        var $el = $(e.target);
        if (!$el.is("iframe")) return;
        $el.attr("src", $el.attr("data-src"));
        if ($el.closest(".media.is-type-video").length) {
            $el.wrap('<div class="js-plyr"></div>');
        }
        reinit_videos();
        e.preventDefault();
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Forms : helper
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Empêche le scroll de changer la valeur des champs [type=number]
    $("input[type=number]").on("mousewheel", function (e) {
        $(this).trigger("blur");
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Forms : repeater
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $main
        .find(".js-form-repeater:not(.js-form-repeater-disabled)")
        .each(function (idx, section) {
            var $section = $(section)
                .nextUntil(":not(.js-form-repeater)")
                .addBack()
                .last();
            var $cloner = $(
                '<p class="' +
                ($section.hasClass("formTable_r") ? "formTable_caption" : "form_p") +
                '"><button type="button" class="btn btn-grey js-form-repeater-clone"' +
                ($section.get(0).hasAttribute("data-repeater-id")
                    ? 'data-repeater-id="' +
                    $section.get(0).getAttribute("data-repeater-id") +
                    '"'
                    : "") +
                '><span class="icon-add"></span> ' +
                ($section.get(0).hasAttribute("data-repeater-btn")
                    ? $section.get(0).getAttribute("data-repeater-btn")
                    : "Ajouter") +
                "</button></p>"
            );
            var isOptional = $section.hasClass("js-form-repeater-optional");
            if ($section.next().find(".js-form-repeater-clone").length) return;
            $section.after($cloner);
            form_repeater_update_idx($cloner);
            $cloner
                .find(".js-form-repeater-clone")
                .on("click", trigger_form_repeater_cb)
                .data("repeater_to_clone", $section.get(0).outerHTML);
            if (isOptional) {
                var $sectionInputNotEmpty = $section
                    .find(
                        'input:not([type="checkbox"]):not([type="radio"]),select,textarea'
                    )
                    .filter(function (ydx, el) {
                        return el.value && el.value != "";
                    });
                var $sectionCheckNotEmpty = $section.find(
                    'input[type="checkbox"]:checked,input[type="radio"]:checked'
                );
                if (!$sectionInputNotEmpty.length && !$sectionCheckNotEmpty.length) {
                    $section.remove();
                }
            }
        });

    function trigger_form_repeater_cb(event) {
        var $btn = $(this);
        trigger_form_repeater($btn);
    }

    function trigger_form_repeater($btn, accNoDirectOpen) {
        var $trigger = $btn.closest("p");
        var $form = $trigger.closest("form");
        // var $section = $trigger.prev(".js-form-repeater");
        // var $clone = $section.clone();
        var $clone = $($btn.data("repeater_to_clone"));
        var hasAccs = false;
        // if (!$section.length) {
        //   return;
        // }
        $clone
            .find(
                'input:not([type="checkbox"]):not([type="radio"]), textarea, select'
            )
            .val("")
            .prop("disabled", false);
        $clone
            .find('input[type="radio"], input[type="checkbox"]')
            .prop("checked", false);
        $clone
            .find(
                ".form_p.is-error input, .form_p.is-error textarea, .form_p.is-error select"
            )
            .each(function (idx, input) {
                form_validation_remove_error(input);
            });
        if ($clone.is(".js-acc")) {
            acc_reset($clone.get(0));
            hasAccs = true;
        }
        $clone.find(".js-acc").each(function (idx, acc) {
            acc_reset(acc);
            hasAccs = true;
        });
        if (
            $clone.find('input[name^="siret["]').length &&
            $trigger.closest("form").find('input[name="siret[0]"]').length
        ) {
            $clone
                .find('input[name^="siret["]')
                .val(
                    $trigger
                        .closest("form")
                        .find('input[name="siret[0]"]')
                        .val()
                        .substring(0, 9)
                );
        }
        $trigger.before($clone);
        form_repeater_update_idx($trigger);
        if (hasAccs) {
            accs_build($form);
        }
        if ($clone.is(".js-acc") && !accNoDirectOpen) {
            acc_direct_open($clone);
        }
        $clone.find('.js-file-input input[type="file"]').trigger("change");
        form_cond_init($clone);
        form_auto_sum_init($clone);
        form_local_save_datas($trigger.parent());
    }

    function form_repeater_update_idx($trigger) {
        var $prevs = $.uniqueSort($trigger.prevUntil(":not(.js-form-repeater)"));
        $prevs.each(function (idx, section) {
            var $section = $(section);
            var haveActiveFields = $section.find(
                "input:not([disabled]),select:not([disabled]),textarea:not([disabled])"
            ).length;
            var isOptional = $section.hasClass("js-form-repeater-optional");
            $section.find(".js-section-idx").text(idx + 1);
            $section.find(".js-repeater-delete").remove();
            $section.prepend(
                '<button type="button" class="js-repeater-delete"' +
                (!isOptional && ($prevs.length <= 1 || !haveActiveFields)
                    ? " disabled"
                    : "") +
                '><span class="icon-trash-2"></span><span class="srOnly">Supprimer</span></button>'
            );
            $section.find("label[for]").each(function (k, label) {
                var $label = $(label);
                var oldId = $label.prop("for");
                var newId = oldId.split("__r__")[0] + "__r__" + idx;
                $label.prop("for", newId);
                $label
                    .parent()
                    .find("#" + oldId)
                    .prop("id", newId);
            });
            $section.find("[name]").each(function (k, input) {
                var $input = $(input);
                $(input).prop(
                    "name",
                    $input
                        .prop("name")
                        .replace(/([^\[\]]+)\[[0-9]+\]/gi, "$1[" + idx + "]")
                );
            });
        });
    }

    $main.on("click", ".js-repeater-delete", remove_form_repeater_cb);
    function remove_form_repeater_cb(event) {
        var $btn = $(this);
        remove_form_repeater($btn);
    }

    function remove_form_repeater($btn, force) {
        var $trigger = $btn
            .closest(".js-form-repeater")
            .nextUntil(":not(.js-form-repeater)")
            .addBack()
            .last()
            .next();
        if (force || confirm("Confirmer la suppression ?")) {
            $btn.closest(".js-form-repeater").remove();
            form_repeater_update_idx($trigger);
            form_local_save_datas($trigger.parent());
        }
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Forms : files
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function input_file_init() {
        var $forms = $main.find(".form[novalidate]");
        if (!$forms.length) return;
        $forms.each(function (idx, form) {
            var $form = $(form);
            $form
                .on("change", '.js-file-input input[type="file"]', function (event) {
                    if ($(this).is("[name]")) {
                        input_file_change(this);
                    } else {
                        input_file_change_ajax(this);
                    }
                })
                .find('.js-file-input input[name][type="file"]')
                .trigger("change");
            $form
                .find(".js-file-input")
                .on("click", ".fileInput_fileDelete", input_file_delete);
        });
    }
    input_file_init();

    function input_file_change(input) {
        if (input.files && input.files.length) {
            $(input)
                .closest(".fileInput")
                .find(".fileInput_txt")
                .html(
                    [...input.files]
                        .map(function (v) {
                            return v.name;
                        })
                        .join("<br>")
                );
        }
    }

    function input_file_change_ajax(input) {
        var $input = $(input);
        var $form = $input.closest("form");
        var $submitButton = $form.find('.form_submit [type="submit"]');
        var $parent = $input.closest(".form_p");
        var $field = $input.closest(".fileInput");
        var error = false;
        var fieldName = $input.attr("data-name");
        fieldName = fieldName ? fieldName.split("[")[0] : false;
        var demandeID = window.location.href.split("/demande/");
        if ( demandeID.length > 1 ) {
          var demandeType = 'demande';
        } else {
          var demandeType = 'questionnaire';
          demandeID = window.location.href.split("/questionnaire/");
        }
        demandeID = demandeID.length > 1 ? demandeID[1].split("/")[0] : false;
        if (!input.files || !input.files.length || !demandeID || !fieldName) {
            return;
        }
        //errors
        error = check_input_file_value(input);
        if (error) {
            $parent.addClass("is-error");
            $parent.append('<span class="form_error">' + error + "</span>");
            return;
        }
        //upload
        var dataPost = new FormData();
        for (const file of input.files) {
            dataPost.append("files[]", file);
        }
        dataPost.append("action", "ajax_file_upload");
        dataPost.append("custom_id", demandeID);
        dataPost.append("type", demandeType);
        dataPost.append("field_name", fieldName);
        $field.find(".fileInput_btn").addClass("has-loader").addClass("is-loading");
        $submitButton.prop("disabled", true);
        input.value = "";
        input.type = "";
        input.type = "file";
        $.ajax({
            url: url.ajax,
            type: "POST",
            data: dataPost,
            cache: false,
            dataType: "json",
            processData: false, // Don't process the files
            contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        })
            .done(function (data) {
                // console.log(data);
                if (data.success && data.success.length) {
                    data.success.forEach(function (lk) {
                        $field
                            .find(".fileInput_txt")
                            .append(
                                '<span class="fileInput_file"><button class="fileInput_fileDelete" type="button"><span class="icon-trash-2"></span></button><a class="fileInput_fileLink" href="' +
                                lk +
                                '" target="_blank">' +
                                lk.split(/[\\/]/).pop() +
                                "</a></span>"
                            );
                        $field.append(
                            '<input type="hidden" name="' +
                            fieldName +
                            '_uploaded[]" value="' +
                            lk +
                            '">'
                        );
                    });
                    xls_read_data($input);
                } else {
                    $parent.addClass("is-error");
                    $parent.append('<span class="form_error">' + data.error + "</span>");
                    $input.trigger('file.error');
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                $parent.addClass("is-error");
                $parent.append('<span class="form_error">' + textStatus + "</span>");
            })
            .always(function () {
                $field
                    .find(".fileInput_btn:not(.is-xls-loading)")
                    .removeClass("has-loader")
                    .removeClass("is-loading");
                $submitButton.prop("disabled", false);
                input_file_update_full_state(input);
            });
    }

    function input_file_update_full_state(input) {
        if (!input) return;
        var $input = $(input);
        var $parent = $input.closest(".form_p");
        var isMultiple = input.hasAttribute("multiple");
        var maxFiles =
            isMultiple && input.hasAttribute("data-limit")
                ? parseInt(input.getAttribute("data-limit"))
                : false;
        if (
            maxFiles &&
            $parent.find('input[name][type="hidden"]').length >= maxFiles
        ) {
            $parent.addClass("is-full");
        } else {
            $parent.removeClass("is-full");
        }
        if (!$parent.find(".fileInput_txt").children().length) {
            $parent.find(".fileInput_txt").text("");
        }
    }

    function input_file_delete(event) {
        var $btn = $(this);
        var $field = $btn.closest(".fileInput");
        var $input = $field.find('input[type="file"]:not([name])');
        var urlToDelete = $btn
            .closest(".fileInput_file")
            .find("a[href]")
            .attr("href");
        $field
            .find('input[type="hidden"][name][value="' + urlToDelete + '"]')
            .remove();
        $btn.closest(".fileInput_file").remove();
        input_file_update_full_state(
            $input.get(0)
        );
        xls_reset($input);
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Forms : validation
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function form_validation_init() {
        var $forms = $main.find(".form[novalidate]");
        if (!$forms.length) return;
        $forms.each(function (idx, form) {
            var $form = $(form);
            $form
                .on("submit", form_validation_submit)
                .on(
                    "focus",
                    ".form_p input, .form_p textarea, .form_p select",
                    function () {
                        form_validation_remove_error(this);
                    }
                );
            $form.find(".js-form-save").on("click", function () {
                $form.data("save_btn", true);
            });
        });
    }
    form_validation_init();

    function form_validation_submit(event) {
        var $form = $(this);
        var noValid = false;
        var $submitButton = $form.find('.form_submit [type="submit"]');
        var saveSubmit = $form.data("save_btn");
        var isLocalForm = $form.hasClass("form-local");
        var skipRequired = saveSubmit || isLocalForm;
        $form.data("save_btn", false);
        if ($submitButton.first().prop("disabled")) {
            return;
        }
        $submitButton.prop("disabled", true);
        $form
            .find(".form_p input[name], .form_p textarea[name], .form_p select[name]")
            .each(function (idx, input) {
                var inputValid = form_manage_validity_input(input, skipRequired);
                noValid = noValid || !inputValid;
            });
        $form
            .find('.form_p input[type="file"]:not([name])')
            .each(function (idx, input) {
                var inputValid = form_check_validity_file_ajax(input, skipRequired);
                noValid = noValid || !inputValid;
            });
        $form.find('.form_error-sum').remove();
        $form
            .find('.form_p:not(.is-error) input[type="number"][name][data-check-sum]')
            .each(function (idx, input) {
                var inputValid = form_check_sum_validity_input(input, skipRequired);
                noValid = noValid || !inputValid;
            });

        if (noValid) {
            event.preventDefault();
            $form.find(".js-acc .form_p.is-error").each(function (idx, el) {
                acc_direct_open($(el).closest(".js-acc"));
            });
            scrollToEl($form.find(".form_p.is-error, .form_error-sum").first());
            $submitButton.prop("disabled", false);
        } else if (saveSubmit) {
            $form.append('<input type="hidden" name="save_form" value="1">');
        } else if (isLocalForm) {
            // event.preventDefault();
            if ($form.find('input[name="generate_pdf"]').length) {
                form_append_datas($form);
                $submitButton.prop("disabled", false);
            } else {
                form_local_save_datas($form);
            }
        }
    }

    function form_validation_remove_error(input) {
        $(input)
            .closest(".form_p")
            .removeClass("is-error")
            .find(".form_error")
            .remove();
    }

    function form_check_validity_file_ajax(input, noRequired) {
        var $input = $(input);
        var $parent = $input.closest(".form_p");
        var error = false;
        noRequired = noRequired || false;
        form_validation_remove_error(input);
        if (
            !noRequired &&
            input.required &&
            !$parent.find('input[name][type="hidden"]').length
        ) {
            error = str.field_invalid_required;
        }
        if (error) {
            $parent.addClass("is-error");
            $parent.append('<span class="form_error">' + error + "</span>");
            return false;
        }
        return true;
    }

    function form_check_validity_input(input, noRequired) {
        var $input = $(input);
        var error = false;
        noRequired = noRequired || false;
        if (!input.disabled && !input.validity.valid) {
            if (input.validity.valueMissing) {
                if (!noRequired) {
                    error = str.field_invalid_required;
                }
            } else if (input.type == "email" && input.validity.typeMismatch) {
                error = str.field_invalid_email;
            } else if (input.type == "url" && input.validity.typeMismatch) {
                error = str.field_invalid_url;
            } else if (input.validity.tooLong) {
                error = str.field_invalid_maxlength.replace(
                    "%s",
                    $(input).attr("maxlength")
                );
            } else if (
                input.type == "number" &&
                (input.validity.rangeOverflow || input.validity.rangeUnderflow)
            ) {
                if ($(input).attr("min") && $(input).attr("max")) {
                    error = str.field_invalid_number_out
                        .replace("%1$s", $(input).attr("min"))
                        .replace("%2$s", $(input).attr("max"));
                } else if ($(input).attr("max")) {
                    error = str.field_invalid_number_over.replace(
                        "%s",
                        $(input).attr("max")
                    );
                } else {
                    error = str.field_invalid_number_under.replace(
                        "%s",
                        $(input).attr("min")
                    );
                }
            } else if (input.type == "number") {
                error = str.field_invalid_number;
            } else if (
                input.validity.patternMismatch &&
                input.hasAttribute("pattern")
            ) {
                var patternInfos = input
                    .getAttribute("pattern")
                    .replace(/[^a-z0-9,]/gi, "")
                    .match(/^(w|d)(?:([0-9]+),([0-9]+))?$/i);
                error = str.field_invalid_pattern;
                if (patternInfos) {
                    if (patternInfos[1] && patternInfos[1] === "d") {
                        if (patternInfos[2]) {
                            error = str.field_invalid_exactlength_number.replace(
                                "%s",
                                patternInfos[2]
                            );
                        } else {
                            error = str.field_invalid_pattern_number;
                        }
                    } else if (patternInfos[2]) {
                        error = str.field_invalid_exactlength.replace(
                            "%s",
                            patternInfos[2]
                        );
                    }
                }
            }
        } else if (
            !input.disabled &&
            input.validity.valid &&
            input.type == "file"
        ) {
            error = check_input_file_value(input);
        } else if (
            !input.disabled &&
            input.validity.valid &&
            input.type == "text" &&
            input.value &&
            input.hasAttribute("data-date")
        ) {
            var errorDate = false;
            var dateInfos = input.value.match(
                /^(01|02|03|04|05|06|07|08|09|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31)\/(01|02|03|04|05|06|07|08|09|10|11|12)\/(\d{4})$/i
            );
            if (!dateInfos || !dateInfos[1] || !dateInfos[2] || !dateInfos[3]) {
                errorDate = true;
                error = str.field_invalid_date_format;
            } else if (
                isNaN(new Date(dateInfos[3] + "/" + dateInfos[2] + "/" + dateInfos[1]))
            ) {
                errorDate = true;
                error = str.field_invalid_date_invalid;
            }
            if (
                !errorDate &&
                input.hasAttribute("data-year") &&
                dateInfos[3] != input.getAttribute("data-year")
            ) {
                errorDate = true;
                error = str.field_invalid_year_actions.replace(
                    "%s",
                    input.getAttribute("data-year")
                );
            }
            var inputDate = !errorDate
                ? new Date(dateInfos[3] + "/" + dateInfos[2] + "/" + dateInfos[1])
                : false;
            if (
                !errorDate &&
                (input.hasAttribute("data-futur") || input.hasAttribute("data-past"))
            ) {
                var currentDate = new Date();
                if (input.hasAttribute("data-futur") && inputDate < currentDate) {
                    errorDate = true;
                    error = str.field_invalid_date_futur;
                } else if (input.hasAttribute("data-past") && inputDate > currentDate) {
                    errorDate = true;
                    error = str.field_invalid_date_past;
                }
            }
            if (!errorDate && input.hasAttribute("data-min-date")) {
                var checkDate = new Date(input.getAttribute("data-min-date"));
                var checkDateFormat =
                    pad(checkDate.getDate()) +
                    "/" +
                    pad(checkDate.getMonth() + 1) +
                    "/" +
                    pad(checkDate.getFullYear());
                if (inputDate < checkDate) {
                    errorDate = true;
                    error = str.field_invalid_date_min.replace("%s", checkDateFormat);
                }
            }
            if (!errorDate && input.hasAttribute("data-max-date")) {
                var checkDate = new Date(input.getAttribute("data-max-date"));
                var checkDateFormat =
                    pad(checkDate.getDate()) +
                    "/" +
                    pad(checkDate.getMonth() + 1) +
                    "/" +
                    pad(checkDate.getFullYear());
                if (inputDate > checkDate) {
                    errorDate = true;
                    error = str.field_invalid_date_max.replace("%s", checkDateFormat);
                }
            }
        } else if (
            !input.disabled &&
            input.value &&
            input.hasAttribute("data-exactlength") &&
            input.value.length !== parseInt(input.getAttribute("data-exactlength"))
        ) {
            error = str.field_invalid_exactlength.replace(
                "%s",
                $input.attr("data-exactlength")
            );
        } else if (
            !input.disabled &&
            input.value &&
            input.name.indexOf("siret[") === 0 &&
            $input.closest("form").find('input[name="siret[0]"]').length &&
            $input
                .closest("form")
                .find('input[name="siret[0]"]')
                .first()
                .val()
                .substring(0, 9) !== input.value.substring(0, 9)
        ) {
            error = str.field_invalid_siret;
        } else if (
            !input.disabled &&
            input.value &&
            input.name === "organisme_num_activite"
        ) {
            if (!(input.value in ndas)) {
                error = str.field_invalid_nda_not_checked;
            } else if (ndas[input.value].error != "") {
                error = ndas[input.value].message;
            }
        }
        return error;
    }

    function form_manage_validity_input(input, noRequired) {
        var $input = $(input);
        var $parent = $input.closest(".form_p");
        noRequired = noRequired || false;
        form_validation_remove_error(input);
        var error = form_check_validity_input(input, noRequired);
        if (error) {
            $parent.addClass("is-error");
            $parent.append('<span class="form_error">' + error + "</span>");
            return false;
        }
        return true;
    }

    function check_input_file_value(input) {
        var $input = $(input);
        var $parent = $input.closest(".form_p");
        var isAjaxFile = $input.not("[name]");
        var error = false;
        if (input.files && input.files.length) {
            var isMultiple = input.hasAttribute("multiple");
            var errorLimit = false;
            var errorType = false;
            var errorSize = false;
            if (isMultiple && input.hasAttribute("data-limit")) {
                var maxFiles = parseInt(input.getAttribute("data-limit"));
                var nbFiles = input.files.length;
                if (isAjaxFile) {
                    nbFiles += $parent.find('input[name][type="hidden"]').length;
                }
                if (nbFiles > maxFiles) {
                    errorLimit = true;
                }
            }
            for (const file of input.files) {
                if (input.hasAttribute("accept")) {
                    let acceptedExts = input
                        .getAttribute("accept")
                        .toLowerCase()
                        .replace(/[^0-9a-z,]/gi, "")
                        .split(",");
                    let ext = file.name.toLowerCase().split(".");
                    ext = ext[ext.length - 1].replace(/[^0-9a-z]/gi, "");
                    if (!acceptedExts.includes(ext)) {
                        errorType = true;
                    }
                }
                if (input.hasAttribute("data-size")) {
                    var maxSize =
                        parseInt(input.getAttribute("data-size")) * (1024 * 1024);
                    if (file.size > maxSize) {
                        errorSize = true;
                    }
                }
            }

            if (errorLimit) {
                error = str.field_invalid_files_limit.replace(
                    "%s",
                    input.getAttribute("data-limit")
                );
            } else if (errorType) {
                error = (
                    isMultiple
                        ? str.field_invalid_files_type
                        : str.field_invalid_file_type
                ).replace("%s", input.getAttribute("accept").replace(/,\s*/gi, ", "));
            } else if (errorSize) {
                error = (
                    isMultiple
                        ? str.field_invalid_files_size
                        : str.field_invalid_file_size
                ).replace("%s", input.getAttribute("data-size"));
            }
        }
        return error;
    }

    function form_check_sum_validity_input(input, noRequired) {
        var $input = $(input);
        let tF = 0;
        noRequired = noRequired || false;
        if (noRequired) {
          return true;
        }
        if (input.hasAttribute("step")) {
            if (input.getAttribute("step").match(/^[0-9]\.[0-9]$/)) {
                tF = 1;
            } else if (input.getAttribute("step").match(/^[0-9]\.[0-9]{2}$/)) {
                tF = 2;
            }
        }
        let $controllers = $input
            .closest("form")
            .find(
                '[name^="' +
                $input.attr("data-check-sum").split(",").join('"],[name^="') +
                '"]'
            );
        if ($input.closest('.is-error').length || !$controllers.length || $controllers.filter(function (idx, ctr) { return $(ctr).closest(".is-error").length; }).length) return true;
        let inputSum = input.value ? parseFloat(input.value) : 0;
        let sum = 0;
        $controllers.each(function (idx, el) {
            sum += el.value ? parseFloat(el.value) : 0;
        });
        if (sum != inputSum) {
            let $firstController = $controllers.first().closest('.form_p');
            if ($firstController.closest('.form_cols').length) {
                $firstController = $firstController.closest('.form_cols');
            }
            $controllers.closest('.form_p').addClass('is-error');
            let error = $input.attr('data-check-sum-message') && str[$input.attr('data-check-sum-message')] ? str[$input.attr('data-check-sum-message')] : str.field_invalid_check_sum;
            error = error.replace("%1$s", '<a class="js-scroller" data-scroll-parent=".form_p" data-scroll-focus href="#' + $input.attr('id') + '">')
                .replace("%2$s", '</a>');
            let $error = $('<p class="form_error form_error-sum">' + error + '</p>');
            $firstController.before($error);
            return false;
        }
        return true;
    }


    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Form : condition
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function form_cond_init($cont) {
        ($cont && $cont.length ? $cont : $main)
            .find("[data-form-if-name][data-form-if-value]")
            .each(function (index, el) {
                var $el = $(el);
                var conditions = $el.attr("data-form-if-value").split("||");
                var isInRepeater = false;
                var $controllers = [];
                $controllers = $el
                    .closest(".js-form-repeater")
                    .find(
                        '[name^="' +
                        $el.attr("data-form-if-name") +
                        '["]:not([type="checkbox"]), [type="checkbox"][name^="' +
                        $el.attr("data-form-if-name") +
                        '["][value="' +
                        conditions.join(
                            '"], [type="checkbox"][name^="' +
                            $el.attr("data-form-if-name") +
                            '["][value="'
                        ) +
                        '"]'
                    );
                if ($controllers.length) {
                    isInRepeater = true;
                } else {
                    $controllers = $el
                        .closest("form, .form")
                        .find(
                            '[name="' +
                            $el.attr("data-form-if-name") +
                            '"], [type="checkbox"][name^="' +
                            $el.attr("data-form-if-name") +
                            '["][value="' +
                            conditions.join(
                                '"], [type="checkbox"][name^="' +
                                $el.attr("data-form-if-name") +
                                '["][value="'
                            ) +
                            '"]'
                        );
                }
                if (!$controllers.length || !conditions || !conditions.length) return;
                $el
                    .find("input:disabled,select:disabled,textarea:disabled")
                    .filter(function (idx, kl) {
                        return (
                            $(kl)
                                .closest("[data-form-if-name][data-form-if-value]")
                                .get(0) === $el.get(0)
                        );
                    })
                    .attr("data-init-disabled", "1");
                form_cond_hide($el, true);
                $el.addClass("js-form-if-is-init");
                $controllers
                    .on("change", function () {
                        var noValid = false;
                        if (this.type == "checkbox") {
                            noValid = !$controllers.filter(":checked").length;
                        } else if (this.type == "number") {
                            noValid = !conditions.filter(
                                (v) => parseFloat($(this).val()) >= parseFloat(v)
                            ).length;
                        } else {
                            noValid = !conditions.includes($(this).val());
                        }
                        if (noValid) {
                            form_cond_hide($el);
                        } else {
                            form_cond_show($el);
                        }
                    })
                    .filter(
                        'input:not([type="radio"]),textarea,select,input[type="radio"]:checked'
                    )
                    .trigger("change");
            });
        ($cont && $cont.length ? $cont : $main)
            .find("[data-form-if-required-name][data-form-if-required-value]")
            .each(function (index, el) {
                var $el = $(el);
                var conditions = $el.attr("data-form-if-required-value").split("||");
                var isInRepeater = false;
                var $controllers = [];
                $controllers = $el
                    .closest(".js-form-repeater")
                    .find(
                        '[name^="' +
                        $el.attr("data-form-if-required-name") +
                        '["]:not([type="checkbox"]), [type="checkbox"][name^="' +
                        $el.attr("data-form-if-required-name") +
                        '["][value="' +
                        conditions.join(
                            '"], [type="checkbox"][name^="' +
                            $el.attr("data-form-if-required-name") +
                            '["][value="'
                        ) +
                        '"]'
                    );
                if ($controllers.length) {
                    isInRepeater = true;
                } else {
                    $controllers = $el
                        .closest("form, .form")
                        .find(
                            '[name="' +
                            $el.attr("data-form-if-required-name") +
                            '"], [type="checkbox"][name^="' +
                            $el.attr("data-form-if-required-name") +
                            '["][value="' +
                            conditions.join(
                                '"], [type="checkbox"][name^="' +
                                $el.attr("data-form-if-required-name") +
                                '["][value="'
                            ) +
                            '"]'
                        );
                }
                if (!$controllers.length || !conditions || !conditions.length) return;
                $el.removeAttr("required");
                $controllers
                    .on("change", function () {
                        form_validation_remove_error(el);
                        var noValid = false;
                        if (this.type == "checkbox") {
                            noValid = !$controllers.filter(":checked").length;
                        } else if (this.type == "number") {
                            noValid = !conditions.filter(
                                (v) => parseFloat($(this).val()) >= parseFloat(v)
                            ).length;
                        } else {
                            noValid = !conditions.includes($(this).val());
                        }
                        if (noValid) {
                            $el.removeAttr("required");
                        } else {
                            $el.attr("required", "true");
                        }
                    })
                    .filter(
                        'input:not([type="radio"]),textarea,select,input[type="radio"]:checked'
                    )
                    .trigger("change");
            });
    }
    form_cond_init();

    function form_cond_hide($el, keepError, keepState) {
        $el.hide();
        if (!keepState) {
            $el.addClass("js-form-if-is-hide");
        }
        $el
            .find("input,select,textarea")
            .filter(function (idx, kl) {
                return (
                    $(kl).closest("[data-form-if-name][data-form-if-value]").get(0) ===
                    $el.get(0)
                );
            })
            .attr("disabled", "disabled");
        if (!keepError) {
            $el.removeClass("is-error").find(".form_error").remove();
            $el.find(".is-error").removeClass("is-error");
        }
        var $ifChild = $el.find(".js-form-if-is-init").first();
        if ($ifChild.length && !$ifChild.hasClass("js-form-if-is-hide")) {
            form_cond_hide($ifChild, keepError, true);
        }
    }

    function form_cond_show($el, keepState) {
        $el.show();
        if (!keepState) {
            $el.removeClass("js-form-if-is-hide");
        }
        $el
            .find("input,select,textarea")
            .filter(function (idx, kl) {
                return (
                    $(kl).closest("[data-form-if-name][data-form-if-value]").get(0) ===
                    $el.get(0)
                );
            })
            .not("[data-init-disabled]")
            .removeAttr("disabled");
        var $ifChild = $el.find(".js-form-if-is-init").first();
        if ($ifChild.length && !$ifChild.hasClass("js-form-if-is-hide")) {
            form_cond_show($ifChild, true);
        }
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Form : auto sum
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function form_auto_sum_init($cont) {
        ($cont && $cont.length ? $cont : $main)
            .find("[data-auto-sum]")
            .each(function (index, el) {
                let $el = $(el);
                let tF = 0;
                if (el.hasAttribute("step")) {
                    if (el.getAttribute("step").match(/^[0-9]\.[0-9]$/)) {
                        tF = 1;
                    } else if (el.getAttribute("step").match(/^[0-9]\.[0-9]{2}$/)) {
                        tF = 2;
                    }
                }
                let $controllers = $el
                    .closest("form")
                    .find(
                        '[name="' +
                        $el.attr("data-auto-sum").split(",").join('"],[name="') +
                        '"]'
                    );
                if (!$controllers.length) return;
                $controllers
                    .on("change", function () {
                        let sum = 0;
                        $controllers.each(function (index, el) {
                            sum += el.value ? parseFloat(el.value) : 0;
                        });
                        if ($el.is("input")) {
                            $el.val(sum.toFixed(tF));
                        } else {
                            $el.text(sum.toFixed(tF));
                        }
                    })
                    .trigger("change");
            });
    }
    form_auto_sum_init();

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Recaptach
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var recaptcha_is_ready = false;
    var recaptcha_is_loading = false;
    var $recaptchas = [];

    function init_recaptchas() {
        if (!$recaptchas.length) return;
        load_recaptcha();
    }

    function reinit_recaptcha() {
        $recaptchas = $main.find(".g-recaptcha");
        init_recaptchas();
    }
    reinit_recaptcha();

    function load_recaptcha() {
        if (recaptcha_is_ready) {
            return;
        }
        recaptcha_is_loading = true;
        async("https://www.google.com/recaptcha/api.js", recaptcha_loaded);
    }

    function recaptcha_loaded() {
        recaptcha_is_ready = true;
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Demande
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $main.find(".demandeMod_motifTrigger button").on("click", function (event) {
        $(this).closest(".demandeMod").find(".demandeMod_motif").slideToggle(400);
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Sticky (pageNav)
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var $stickyBars = [];
    function sticky_init($cont) {
        $cont = $cont && $cont.length ? $cont : $main;
        $stickyBars = $cont.find(".js-sticky");
    }
    sticky_init();

    function sticky_update_all_height() {
        if (!$stickyBars.length) return;
        $stickyBars.each(function (idx, el) {
            if (is_menu_mobile) {
                $(el).closest("[data-sticky-container]").css("min-height", "");
            } else {
                $(el)
                    .closest("[data-sticky-container]")
                    .css("min-height", $(el).outerHeight());
            }
        });
    }
    sticky_update_all_height();

    function sticky_update_all() {
        if (is_menu_mobile || !$stickyBars.length) return;
        $stickyBars.each(function (idx, el) {
            sticky_update(el);
        });
    }
    sticky_update_all();

    function sticky_update(bar) {
        if (is_menu_mobile) return;
        var $bar = $(bar);
        var $cont = $bar.closest("[data-sticky-container]");
        var contPaddingBottom = $cont.length
            ? parseInt($cont.css("padding-bottom"))
            : 0;
        var $parent = $bar.parent();
        var upToTop = $parent.get(0).getBoundingClientRect().top <= adminBar_h + 0;
        var upToCont =
            !$cont.length ||
            $cont.get(0).getBoundingClientRect().top + $cont.outerHeight() >=
            adminBar_h + 0 + $bar.outerHeight() + contPaddingBottom;
        if (upToTop && upToCont) {
            if (!$bar.hasClass("is-sticked")) {
                $bar.addClass("is-sticked");
                $bar.removeClass("is-sticked-bottom");
                $bar.css("width", $parent.outerWidth() + "px");
            }
        } else {
            if ($bar.hasClass("is-sticked")) {
                if (upToCont) {
                    $bar.removeClass("is-sticked");
                    $bar.removeClass("is-sticked-bottom");
                    $bar.removeAttr("style");
                } else {
                    $bar.addClass("is-sticked-bottom");
                    $bar.removeClass("is-sticked");
                    $bar.removeAttr("style");
                }
            }
        }
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Page barre de navigation
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var $pageNav;
    var $pageNavItems;
    var $pageNavTitles;
    var pageNavTitlesIDs = [];

    function page_nav_init($cont) {
        $cont = $cont && $cont.length ? $cont : $main;
        $pageNav = $cont.find(".pageNav:not(.is-external)");
        $pageNavItems = $pageNav.find("li");
        $pageNavItems.each(function (index) {
            pageNavTitlesIDs.push($(this).find("a").attr("href"));
        });
        $pageNavTitles = $cont.find("h2[id],h3[id]").filter(function (index) {
            return $.inArray("#" + $(this).attr("id"), pageNavTitlesIDs) !== -1;
        });
    }
    page_nav_init();

    function page_nav_update() {
        if (!$pageNav.length || !$pageNavTitles.length) return;
        var $activeTitle = [];
        var $activeItem = false;
        var offset = adminBar_h + 0;
        $pageNavTitles.each(function (idx, el) {
            var $el = $(el);
            // var elMargin = parseInt($el.css('marginTop'));
            // if(elMargin) {
            //   offset += elMargin;
            // }
            if (
                el.previousElementSibling &&
                el.previousElementSibling.getBoundingClientRect().top +
                el.previousElementSibling.clientHeight <=
                offset
            ) {
                $activeTitle = $el;
            }
        });
        if (!$activeTitle.length) {
            $activeTitle = $pageNavTitles.first();
        }
        $activeItem = $pageNav
            .find('a[href="#' + $activeTitle.attr("id") + '"]')
            .closest("li");
        if ($activeItem.length && !$activeItem.hasClass("is-active")) {
            $pageNavItems.removeClass("is-active");
            $activeItem.addClass("is-active");
        }
    }
    page_nav_update();

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Accueil / mission tabs
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $main.find(".homeMissions_cont.js-tabs").on("tabs:change", function (event) {
        var $el = $(this).find(
            '.js-tabs-section:not([aria-hidden="true"]) .flickity-enabled'
        );
        var flkty = $el && $el.length ? $el.data("flickity") : false;
        // console.log(flkty);
        if (flkty) {
            $el.flickity("resize");
        }
    });
    $main.find(".homeMissions_cont.js-tabs").first().tabs({
        class_nav: "homeMissions_nav",
        class_nav_item: "homeMissions_navi",
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Alerte
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $body.on("click", ".js-alert-close", function (event) {
        event.preventDefault();
        Cookies.set(
            "alisfa-hide-alert",
            $(this).closest(".alertBanner").attr("id")
        );
        $(this).closest(".alertBanner").remove();
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Tooltips
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $main.find(".tooltip").on("click", function (event) {
        event.preventDefault();
        var $this = $(this);
        var $text = $(this).find(".tooltip_txt");
        $main.find(".tooltip").not(this).removeClass("is-open");
        $this.removeClass("is-left").removeClass("is-right");
        if (
            $text.get(0).getBoundingClientRect().left + $text.outerWidth() >
            windowW - 10
        ) {
            $this.addClass("is-left");
        } else if ($text.get(0).getBoundingClientRect().left < 10) {
            $this.addClass("is-right");
        }
        $(this).toggleClass("is-open");
    });
    $body.on("click", function (event) {
        if (event.target && !$(event.target).closest(".tooltip").length) {
            $main.find(".tooltip").removeClass("is-open");
        }
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Pagination
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var is_pagination_request = false;
    $body.on("click", ".js-pagination", function (event) {
        var $btn = $(this);
        event.preventDefault();
        if (is_pagination_request) return;
        is_pagination_request = true;
        $.ajax({
            url: url.ajax,
            type: "POST",
            dataType: "json",
            data: { action: "get_next_posts", link: $btn.attr("href") },
        })
            .done(function (data) {
                if (data && data.result && data.result != "") {
                    $btn
                        .closest(".page_content")
                        .find(".archivesActus,.archivesReunions")
                        .append(data.result);
                }
                if (data && data.btn && data.btn != "") {
                    $btn.parent().replaceWith(data.btn);
                } else {
                    $btn.parent().remove();
                }
                if (test_history()) {
                    window.history.replaceState({}, "", $btn.attr("href"));
                }
            })
            .fail(function () {
                // console.log("error");
            })
            .always(function () {
                is_pagination_request = false;
            });
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Sliders mobile
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $(".page-template-home .grid3, .page-template-home .grid4").each(function (
        index,
        el
    ) {
        var $el = $(el);
        var flky = $el.flickity({
            cellAlign: "left",
            wrapAround: false,
            // lazyLoad: 2, //data-flickity-lazyload-srcset & data-flickity-lazyload-src
            pageDots: false,
            groupCells: false,
            contain: true,
            setGallerySize: true,
            prevNextButtons: false,
            watchCSS: true,
            on: {
                ready: function () {
                    setSliderHeightToMax(this);
                },
                resize: function () {
                    // flkty.slides.forEach(slide => slide.style.height = '');
                    //
                    // let heights = flkty.slides.map(slide => slide.offsetHeight),
                    //     max = Math.math.apply(Math, heights);
                    //
                    // flkty.slides.forEach(slide => slide.style.height = max + 'px');
                    setSliderHeightToMax(this);
                },
            },
        });
    });

    function setSliderHeightToMax(slider) {
        slider.cells.forEach(function (cell) {
            cell.element.style.height = "";
        });
        var heights = slider.cells.map(function (cell) {
            return cell.element.offsetHeight;
        });
        var max = Math.max.apply(Math, heights);
        slider.cells.forEach(function (cell) {
            cell.element.style.height = max + "px";
        });
        slider.viewport.style.height = max + "px";
    }

    function resetSlidesHeight() {
        $(
            ".page-template-home .grid3:not(.flickity-enabled) .grid3_i, .page-template-home .grid4:not(.flickity-enabled) .grid4_i"
        ).each(function (index, el) {
            $(el).removeAttr("style").removeAttr("aria-hidden");
        });
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Excel
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var xls_is_ready = false;
    var xls_is_loading = false;

    function xls_load() {
        if (!$main.find(".js-xls").length) return;

        if (xls_is_ready) {
            xls_init();
            return;
        }

        if (!xls_is_loading) {
            xls_is_loading = true;
            async(url.theme + "lib/xlsx.full.min.js", xls_loaded_cb);
        }
    }
    xls_load();

    function xls_loaded_cb() {
        xls_is_ready = true;
        xls_is_loading = false;
        xls_init();
    }

    function xls_init() {
        $('.js-xls .fileInput_btn').after('<button type="button" class="fileInput_btn js-xls-update">' + str.xls_extract_data + '</button>');
        $('.js-xls').each(function(){
            xls_read_data($(this).find('input[type="file"]:not([name])'));
        });
    }

    function xls_read_data($input) {
        var $xlsContainer = $input.closest(".js-xls");
        var file = $xlsContainer.find('.fileInput_fileLink').attr('href');
        if (!file) {
            return;
        }
        $xlsContainer
            .find("label.fileInput_btn")
            .addClass("has-loader")
            .addClass("is-xls-loading")
            .addClass("is-loading");
        $.ajax({
            url: file,
            type: "GET",
            xhrFields: {
              responseType: 'arraybuffer'
            }
        }).done(function(response){
          var data = new Uint8Array(response);
            var workbook = XLSX.read(data, { type: 'array', cellDates: true });
            // Récupération et formatage des données
            var error = false;
            var formatedRows = [];
            var sheetName = "Les salariés";
            if (workbook.SheetNames && workbook.SheetNames.length) {
                for (let idx = 0; idx < workbook.SheetNames.length; idx++) {
                    if (
                        ["les salariés", "salariés", "les salaries", "salaries"].includes(
                            workbook.SheetNames[idx].toLowerCase().trim()
                        ) || workbook.SheetNames.length == 1
                    ) {
                        sheetName = workbook.SheetNames[idx];
                    }
                }
            }
            if (!sheetName) {
                error = str.xls_sheet_not_found;
            } else {
                var excelRows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
                    header: 1,
                });
                if (!excelRows || !excelRows.length) {
                    error = str.xls_no_row;
                } else {
                    var firstLine = false;
                    var hintPassed = false;
                    for (let idx = 0; idx < excelRows.length; idx++) {
                        var row = excelRows[idx];
                        if (row && row.length) {
                            if (
                                hintPassed === false &&
                                row[0] &&
                                row[0] != "" &&
                                [
                                    "intitulé du poste",
                                    "intitule du poste",
                                    "poste",
                                    "intitulé",
                                    "intitule",
                                ].includes(row[0].toLowerCase())
                            ) {
                                hintPassed = idx;
                            } else if (
                                hintPassed &&
                                firstLine === false &&
                                row[0] &&
                                row[0] != ""
                            ) {
                                firstLine = idx + 1; // on saute également la première ligne du fichier qui contient un exemple de données
                            }
                            if (firstLine !== false && idx >= firstLine && row[0] && row[0] != "") {
                                formatedRows.push(xls_format_cells(row));
                            }
                        }
                    }
                    if (!formatedRows || !formatedRows.length) {
                        error = str.xls_no_employee_row;
                    }
                }
            }
            $xlsContainer
                .find("label.fileInput_btn")
                .removeClass("has-loader")
                .removeClass("is-xls-loading")
                .removeClass("is-loading");
            $xlsContainer.data("xls_datas", formatedRows);
            if (!error) {
                $xlsContainer.addClass("js-xls-ready");
            } else {
                $xlsContainer.addClass("is-error");
                $xlsContainer.append(
                    '<span class="form_error">'+error+'</span>'
                );
            }
      }).fail(function(){
          $xlsContainer
              .find("label.fileInput_btn")
              .removeClass("has-loader")
              .removeClass("is-xls-loading")
              .removeClass("is-loading");
      });
    };

    function xls_reset($el) {
        $el
            .closest(".js-xls")
            .removeClass("js-xls-ready")
            .find(".fileInput_txt")
            .html("");
    }

    function xls_get_form_names() {
        return [
            {
                name: "salarie_intitule_poste",
                key: 0,
            },
            {
                name: "salarie_nouvel_emploi_repere",
                key: 1,
                format: {
                    1: "animateur_activite",
                    2: "animateur",
                    3: "intervenant_social",
                    4: "intervenant_specialise",
                    5: "animation_petite_enfance",
                    6: "accompagnement_petite_enfance_parentalite",
                    7: "education_petite_enfance",
                    8: "coordinateur_encadrement",
                    9: "directeur_cadre_federal",
                    10: "assistant_gestion_direction",
                    11: "personnel_administratif_financier",
                    12: "charge_accueil",
                    13: "secretaire",
                    14: "personnel_maintenance_service_restauration",
                    15: "personnel_medical_paramedical",
                },
            },
            {
                name: "salarie_secteur_activite",
                key: 2,
                format: {
                    1: "pilotage_administratif",
                    2: "petite_enfance",
                    3: "enfance_jeunesse",
                    4: "adultes_insertion",
                    5: "seniors",
                    6: "personnel_de_service",
                    7: "autre",
                },
            },
            {
                name: "salarie_dernier_diplome",
                key: 3,
            },
            {
                name: "salarie_num_secu",
                key: 4,
            },
            {
                name: "salarie_travailleur_handicape",
                key: 5,
                conv: "check",
                allVal: "oui",
                nullVal: "non",
            },
            {
                name: "salarie_type_contrat",
                key: 6,
                format: {
                    1: "cdi",
                    2: "cdd",
                    3: "cdii",
                    4: "cee",
                },
            },
            {
                name: "salarie_nb_contrats",
                key: 7,
                conv: "int",
            },
            {
                name: "salarie_statut_cadre",
                key: 8,
                conv: "check",
                allVal: "oui",
                nullVal: "non",
            },
            {
                name: "salarie_nature_contrat",
                key: 10,
                conv: "check",
                allVal: "temps_partiel",
            },
            // si temps partiel et temps plein sont cochés, on part sur un temps plein,
            // du coup, on récupère la valeur après le temps partiel, pour qu’elle l’écrase au besoin
            {
                name: "salarie_nature_contrat",
                key: 9,
                conv: "check",
                allVal: "temps_plein",
            },
            {
                name: "salarie_nb_heures_payees",
                key: 11,
                conv: "int",
            },
            {
                name: "salarie_contrat_aide",
                key: 12,
                conv: "check",
                allVal: "pec",
                nullVal: "non",
            },
            {
                name: "salarie_contrat_aide",
                key: 13,
                allVal: "autre",
            },
            {
                name: "salarie_contrat_aide_autre",
                key: 13,
            },
            {
                name: "salarie_contrat_formation_alternance",
                key: 14,
                conv: "check",
                allVal: "contrat_professionnalisation",
                nullVal: "non",
            },
            {
                name: "salarie_contrat_formation_alternance",
                key: 15,
                conv: "check",
                allVal: "contrat_apprentissage",
            },
            {
                name: "salarie_points_nouvelle_pesee",
                key: 16,
                conv: "int",
            },
            {
                name: "salarie_nb_points_anciennete_branche",
                key: 17,
                conv: "float",
            },
            {
                name: "salarie_nb_points_acquisition_competences_emploi_repere",
                key: 18,
                conv: "float",
            },
            {
                name: "salarie_montant_maintien_salaire",
                key: 19,
                conv: "float",
            },
            {
                name: "salarie_salaire_brut_annuel",
                key: 20,
                conv: "float",
            },
            {
                name: "salarie_date_embauche",
                key: 21,
            },
            {
                name: "salarie_depart",
                key: 22,
                allVal: "oui",
                nullVal: "non",
            },
            {
                name: "salarie_depart_date",
                key: 22,
            },
            {
                name: "salarie_depart_motif",
                key: 23,
                format: {
                    f: "fin_contrat",
                    d: "demission",
                    l: "licenciement",
                    le: "licenciement_economique",
                    rc: "rupture_conventionnelle",
                    rp: "rupture_periode_essai",
                    i: "inaptitude",
                    r: "retraite",
                    a: "autre",
                    _other_: "autre",
                },
            },
            {
                name: "salarie_depart_motif_autre",
                key: 23,
            },
            {
                name: "salarie_nb_arrets_maladie",
                key: 24,
                conv: "int",
            },
            {
                name: "salarie_nb_arrets_maladie_moins_4_jours",
                key: 25,
                conv: "int",
            },
            {
                name: "salarie_nb_jours_absence_maladie",
                key: 26,
                conv: "float",
            },
        ];
    }

    function xls_format_cells(row) {
        // console.log(row);
        var formNames = xls_get_form_names();
        var formatedCell = {};
        formNames.forEach((formInput) => {
            var val = false;
            if (row[formInput.key] && row[formInput.key] instanceof Date) {
                val =
                    row[formInput.key].getDate().toString().padStart(2, "0") +
                    "/" +
                    (row[formInput.key].getMonth() + 1).toString().padStart(2, "0") +
                    "/" +
                    row[formInput.key].getFullYear();
            } else {
                val =
                    row[formInput.key] != null ? (row[formInput.key] + "").trim() : false;
            }
            if (formInput.conv === "check" && val == 0) {
                val = false;
            }
            if (val && val != "") {
                if (formInput.format) {
                    val = val.toLowerCase();
                    val = formInput.format[val] ? formInput.format[val] : false;
                    if (!val && formInput.format["_other_"]) {
                        val = formInput.format["_other_"];
                    }
                }
                if (formInput.allVal) {
                    val = ["o", "no", "non"].includes(val.toLowerCase())
                        ? false
                        : formInput.allVal;
                }
            } else {
                val = false;
            }
            if (formInput.nullVal && val === false) {
                val = formInput.nullVal;
            }
            if (val !== false && formInput.conv) {
                if (formInput.conv === "int") {
                    val = Math.round(parseFloat(val.replace(",", "."))) + "";
                } else if (formInput.conv === "float") {
                    val = parseFloat(val.replace(",", ".")) + "";
                }
            }
            formatedCell[formInput.name] = val || formatedCell[formInput.name];
        });
        return formatedCell;
    }

    $main.on("click", ".js-xls-update", xls_update_dom);

    function xls_update_dom(e) {
        e.preventDefault();
        var $btn = $(this);
        var $xlsContainer = $btn.closest(".js-xls");
        var rows = $xlsContainer.data("xls_datas");
        if (!rows || !rows.length) return;
        var eraseVals =
            !xls_has_values($btn) ||
            confirm(
                "Attention, l’importation du fichier écrasera les données renseignées ci-dessous. Confirmer ?"
            );
        if (!eraseVals) return;
        xls_remove_vals($btn);
        $btn.addClass("has-loader").addClass("is-loading");
        setTimeout(() => {
            xls_set_datas($btn, rows);
        }, 500);
    }

    function xls_set_datas($btn, rows) {
        var formNames = xls_get_form_names();
        var $form = $btn.closest(".form");
        var $repeaterBtn = $form.find(".js-form-repeater-clone");
        // console.log(rows);
        rows.forEach((row, idx) => {
            if (idx > 0) {
                trigger_form_repeater($repeaterBtn, true);
            }
            formNames.forEach((formInput) => {
                if (row[formInput.name]) {
                    let $input = $form.find(
                        'input[name="' +
                        formInput.name +
                        "[" +
                        idx +
                        ']"]:not([type="radio"]):not([type="checkbox"]), textarea[name="' +
                        formInput.name +
                        "[" +
                        idx +
                        ']"], select[name="' +
                        formInput.name +
                        "[" +
                        idx +
                        ']"]'
                    );
                    if ($input.length) {
                        $input.val(row[formInput.name]);
                        if ($input.attr('maxlength')) {
                          $input.val($input.val().substring(0, $input.attr('maxlength')));
                        }
                        let error = form_check_validity_input($input.get(0), true);
                        if (error) {
                            $input.val("");
                        } else {
                            $input.trigger("change");
                        }
                    } else {
                        $form
                            .find(
                                'input[type="radio"][name="' +
                                formInput.name +
                                "[" +
                                idx +
                                ']"][value="' +
                                row[formInput.name] +
                                '"]'
                            )
                            .prop("checked", true)
                            .trigger("change");
                    }
                }
            });
        });
        $btn.removeClass("has-loader").removeClass("is-loading");
    }

    function xls_has_values($btn) {
        var $form = $btn.closest(".form");
        if ($form.find(".js-form-repeater").length > 1) {
            return true;
        }
        var $inputs = $form
            .find(
                ".js-form-repeater input, .js-form-repeater textarea, .js-form-repeater select"
            )
            .filter(function (idx, el) {
                return (
                    ((el.type == "radio" || el.type == "checkbox") && el.checked) ||
                    (el.type != "radio" &&
                        el.type != "checkbox" &&
                        el.value &&
                        el.value != "")
                );
            });
        return $inputs.length > 0;
    }

    function xls_remove_vals($btn) {
        var $form = $btn.closest(".form");
        $form.find(".js-form-repeater + .js-form-repeater").remove();
        form_repeater_update_idx($form.find(".js-form-repeater-clone").parent());
        $form
            .find(
                '.js-form-repeater input:not([type="radio"]):not([type="checkbox"]), .js-form-repeater input[type="radio"]:checked, .js-form-repeater input[type="checkbox"]:checked, .js-form-repeater textarea, .js-form-repeater select'
            )
            .each(function (idx, el) {
                if (el.type == "radio" || el.type == "checkbox") {
                    el.checked = false;
                } else if (el.type == "select") {
                    el.selectedIndex = 0;
                } else {
                    el.value = "";
                }
            });
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Keys event
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $html.on("keydown", function (event) {
        if (event.which == 27) {
            // menu_mobile_close();
            // closeSubMenu(true);
            // modale_close();
        }
    });

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //On resize
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $window.on("resize", function (event) {
        update_dimensions();
        $window.trigger("scroll");
    });

    // Avec debounce
    var onResizeDebounce = debounce(function () {
        setCssVarVH();
        resetSlidesHeight();
        sticky_update_all_height();
        // grid_init();
    }, 300);
    $window.on("resize", onResizeDebounce);

    $window.trigger("resize");

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Media queries
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // var mediaQuery = w.matchMedia('(min-width: 768px)');
    // function mediaQueryCheck(e) {
    //   if (e.matches) {
    //     console.log('Media Query Matched!');
    //   }
    // }
    // mediaQuery.addListener(mediaQueryCheck);
    // mediaQueryCheck(mediaQuery);

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //On scroll
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var ticking = false;
    $window.on("scroll", function (event) {
        update_scroll();
        requestTick();
    });

    function requestTick() {
        if (!ticking) {
            ticking = true;
            w.requestAnimationFrame(trigger_scroll);
        }
    }

    function trigger_scroll() {
        ticking = false;
        // auto_hide_header();
        sticky_update_all();
        page_nav_update();
        // $window.trigger('resize.adp'); //datepicker
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Qualiopi
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function hide_input() {
        $(".form_p[data-organisme]").addClass("is-hide");

        //   $('input[name="organisme_adresse1"]')
        //     .closest(".form_p")
        //     .addClass("is-hide");

        //   $('input[name="organisme_adresse2"]')
        //     .closest(".form_p")
        //     .addClass("is-hide");

        //   $('input[name="organisme_adresse3"]')
        //     .closest(".form_p")
        //     .addClass("is-hide");

        //   $('input[name="organisme_code_postal"]')
        //     .closest(".form_p")
        //     .addClass("is-hide");

        //   $('input[name="organisme_ville"]').closest(".form_p").addClass("is-hide");

        //   $('input[name="organisme_siret"]').closest(".form_p").addClass("is-hide");

        //   $('input[name="organisme_telephone"]')
        //     .closest(".form_p")
        //     .addClass("is-hide");
    }

    // hide_input();
    // if ($(".form_p[data-organisme] input").val().length > 0) {
    //   $(".form_p[data-organisme]").removeClass("is-hide");
    // }

    var ndas = [];

    $('input[name="organisme_num_activite"]:not(:disabled)').each(function () {
        var $nda = $(this),
            nda = $nda.val(),
            data = {
                error: "",
                message: "",
                raison_sociale: $('input[name="organisme_raison_sociale"]').val(),
                adresse1: $('input[name="organisme_adresse1"]').val(),
                adresse2: $('input[name="organisme_adresse2"]').val(),
                code_postal: $('input[name="organisme_code_postal"]').val(),
                ville: $('input[name="organisme_ville"]').val(),
                siret: $('input[name="organisme_siret"]').val(),
            };
        ndas[nda] = data;
    });

    function display_nda_result(nda, $nda, $parent, data) {
        $parent.attr("data-last-nda", nda);
        $nda.prop("disabled", false);
        $parent.children(".form_error").remove();
        $parent.append('<span class="form_error">' + data.message + "</span>");

        $('input[name="organisme_raison_sociale"]')
            .val(data.raison_sociale)
            .closest(".form_p")
            .removeClass("is-hide");

        $('input[name="organisme_adresse1"]')
            .val(data.adresse1)
            .closest(".form_p")
            .removeClass("is-hide");

        $('input[name="organisme_adresse2"]')
            .val(data.adresse2)
            .closest(".form_p")
            .removeClass("is-hide");

        $('input[name="organisme_adresse3"]')
            .closest(".form_p")
            .removeClass("is-hide");

        $('input[name="organisme_code_postal"]')
            .val(data.code_postal)
            .closest(".form_p")
            .removeClass("is-hide");

        $('input[name="organisme_ville"]')
            .val(data.ville)
            .closest(".form_p")
            .removeClass("is-hide");

        $('input[name="organisme_siret"]')
            .val(data.siret)
            .closest(".form_p")
            .removeClass("is-hide");

        $('input[name="organisme_telephone"]')
            .closest(".form_p")
            .removeClass("is-hide");

        if (data.error !== "") {
            hide_input();
        }
    }

    $body.on(
        "change keyup",
        'input[name="organisme_num_activite"]:not(:disabled)',
        function () {
            var $nda = $(this),
                nda = $nda.val(),
                $parent = $nda.closest(".form_p"),
                $demande_id = $('input[name="demande_id"]').val(),
                $step = $(".espace_step").attr("data-step");

            if (nda.length < 11) {
                hide_input();
                if (!$parent.hasClass("is-error")) {
                    $parent.children(".form_error").remove();
                    $parent.append(
                        '<span class="form_error">Le numéro de déclaration d’activité doit comporter 11 chiffres, veuillez corriger votre saisie</span>'
                    );
                    $parent.addClass("is-error");
                }
            } else if (nda in ndas) {
                display_nda_result(nda, $nda, $parent, ndas[nda]);
            } else {
                $nda.prop("disabled", true);
                $parent.children(".form_error").remove();
                $parent.append(
                    '<span class="form_error">Vérification du numéro de déclaration d’activité</span>'
                );
                $parent.removeClass("is-error");

                $.ajax({
                    url: url.ajax,
                    type: "POST",
                    dataType: "json",
                    data: {
                        action: "get_ajax_organisme",
                        nda: nda,
                        demande_id: $demande_id,
                        step: $step,
                    },
                })
                    .done(function (data) {
                        if (data.error != "failed") {
                            ndas[nda] = data;
                        }
                        display_nda_result(nda, $nda, $parent, data);
                    })
                    .fail(function () {
                        $nda.prop("disabled", false);
                        $parent.children(".form_error").remove();
                        $parent.append(
                            '<span class="form_error">La vérification a échoué, veuillez réessayer</span>'
                        );
                    });
            }
        }
    );

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // Espace négociateur
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

    function download_doc_neg() {
        var $negociateurLinks = $main.find(
            ".page-template-negociateur .page_contentMain a[href^='" +
            url.upload +
            "']"
        );

        if (!$negociateurLinks.length) {
            return;
        }

        $negociateurLinks.on("click", function () {
            $(this).addClass("consulte");
        });

        $(".btn-doc").on("click", function () {
            var $links = $(this).hasClass("nouveau")
                ? $negociateurLinks.filter(":not(.consulte)")
                : $negociateurLinks;
            var linkI = 0;
            $links.each(function () {
                var $link = $(this);
                setTimeout(function () {
                    var anchor = document.createElement("a");
                    anchor.href = $link.attr("href");
                    anchor.setAttribute("download", "");
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                    $link.addClass("consulte");
                }, linkI * 200);
                linkI++;
            });
        });
    }

    function close_nav() {
        if ($pageNav_inner.length === 0) return;
        var $pageNav = $pageNav_inner.find(".pageNav_i.is-active");
        var $matches = $pageNav.attr("class").match(/pageNav_i-\d/);

        $pageNav.on("click", function () {
            if ($pageNav.nextUntil("." + $matches[0]).length !== 0) {
                $pageNav.nextUntil("." + $matches[0]).toggle();
                return false;
            }
        });
    }

    download_doc_neg();
    close_nav();

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // Form Grille d’entretien paritaire : modale compétences
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    let $modalCompetences = [];
    function competences_selection_init() {
        var $btns = $main.find("form button[data-competences-selection]");
        if (
            !$btns.length ||
            !competences ||
            !competences.length ||
            !competences_relations
        ) {
            $btns.closest(".formTable").remove();
            return;
        }
        competences_selection_create_modate();
        $btns.each(function (idx, btn) {
            const $btn = $(btn);
            const $row = $btn.parent().prev();
            $btn
                .on("click", trigger_competences_selection_cb)
                .data("competences-selection-html", $row.get(0).outerHTML);
            $row.remove();
        });
    }
    competences_selection_init();

    function competences_selection_create_modate() {
        if ($modalCompetences.lenght) {
            return;
        }
        const competencesCats = [];
        for (const cat in competences_relations) {
            competencesCats.push(cat === "none" ? "Divers" : cat);
        }
        let htmlCompetences = "";
        let idxCat = 0;
        for (const cat in competences_relations) {
            if (competences_relations[cat] && competences_relations[cat].length) {
                htmlCompetences += `<div class="modalC_theme">`;
                htmlCompetences += `<h3 class="modalC_title f1-36 txt-700" id="competences-cat-anchor-${idxCat}">${cat === "none" ? "Divers" : cat
                    }</h3>`;
                htmlCompetences += `<ul class="modalC_list f1-16">`;
                competences_relations[cat].forEach((v) => {
                    if (competences[v]) {
                        htmlCompetences += `<li class="modalC_check form_check form_check-checkbox"><label><input type="checkbox" value="${v}"><span>${competences[v]}</span></label></li>`;
                    }
                });
                htmlCompetences += `</ul>`;
                htmlCompetences += `</div>`;
            }
            idxCat++;
        }
        $modalCompetences = $(`
            <div class="modal modalC is-hide">
                <div class="modal_inner modalC_inner">
                    <div class="modalC_side">
                        <h2 class="modalC_sideTitle txt-700 f1-20">${str.competences
            }</h2>
                        <div class="modalC_cats">
                            <p class="modalC_catsTitle f1-14">${str.categories
            }</p>
                            <ul class="modalC_catsList f1-20">
                                <li>${competencesCats
                .map(
                    (v, idx) =>
                        `<a href="#competences-cat-anchor-${idx}">${v}</a>`
                )
                .join("</li><li>")}</li>
                            </ul>
                        </div>
                        <p class="modalC_search f1-16">
                            <label class="f1-14" for="competences-search-input">${str.competences_search
            }</label>
                            <input type="text" id="competences-search-input" value="" placeholder="Ex. transmettre">
                        </p>
                        <div class="modalC_help f1-14">
                            <p><strong>À noter</strong></p>
                            <ul>
                                <li>Pas d’obligation de choisir une compétence par famille </li>
                                <li>Pas de nombre minimum</li>
                            </ul>
                            <p><strong>Vous pouvez fermer la fenêtre.</strong></p>
                            <p>Vous pouvez fermer la fenêtre. Il sera toujours possible de venir modifier la sélection.</p>
                        </div>
                    </div>
                    <div class="modalC_content">${htmlCompetences}</div>
                </div>
                <button class="modal_close f1-20 txt-700" type="button"><span>${str.close
            }</span> <span class="icon-x"></span></button>
            </div>`);
        $body.append($modalCompetences);
        $modalCompetences.on("change", 'input[type="checkbox"]', function () {
            if ($(this).is(":checked")) {
                trigger_competences_check($(this));
            } else {
                trigger_competences_uncheck($(this));
            }
        });
        const $competences = $modalCompetences.find(".modalC_check");
        $modalCompetences
            .find('.modalC_search input[type="text"]')
            .on("input", function () {
                const val = normalizeText($(this).val());
                if (val.length >= 3) {
                    $competences.each(function (idx, el) {
                        const $el = $(el);
                        const text = normalizeText($el.text());
                        if (text.includes(val)) {
                            $el.removeClass("is-hide");
                        } else {
                            $el.addClass("is-hide");
                        }
                    });
                    $modalCompetences
                        .find(".modalC_theme")
                        .removeClass("is-hide")
                        .filter(function (idx, el) {
                            return !$(el).find(".modalC_check:not(.is-hide)").length;
                        })
                        .addClass("is-hide");
                } else {
                    $competences.removeClass("is-hide");
                    $modalCompetences.find(".modalC_theme").removeClass("is-hide");
                }
            });
        $modalCompetences
            .find('.modalC_catsList a[href^="#competences-cat-anchor-"]')
            .on("click", function (event) {
                event.preventDefault();
                var $el = $(this);
                var $target = $($el.attr("href"));
                if ($target.length) {
                    var offsetEl =
                        $target.offset().top -
                        $modalCompetences.offset().top +
                        $modalCompetences.scrollTop() -
                        parseInt(
                            $modalCompetences.find(".modalC_content").css("paddingTop")
                        );
                    $modalCompetences.animate(
                        {
                            scrollTop: offsetEl,
                        },
                        300
                    );
                }
            });
    }

    function trigger_competences_selection_cb(event) {
        var $btn = $(this);
        trigger_competences_selection($btn);
    }

    function trigger_competences_selection($btn) {
        const selectID = $btn.attr("data-competences-selection");
        $modalCompetences.data("competences-selection-id", selectID);
        $modalCompetences
            .find('input[type="checkbox"][value]')
            .prop("checked", false)
            .closest(".modalC_check")
            .removeClass("is-checked");
        $btn
            .closest(".formTable")
            .find(".formTable_r .formTable_c:first-child input[value]")
            .each(function (idx, compInputId) {
                $modalCompetences
                    .find('input[type="checkbox"][value="' + compInputId.value + '"]')
                    .prop("checked", true)
                    .closest(".modalC_check")
                    .addClass("is-checked");
            });
        $modalCompetences.find('.modalC_search input[type="text"]').val("");
        $modalCompetences.find(".modalC_check").removeClass("is-hide");
        modal_open($modalCompetences);
    }

    function trigger_competences_check($checkbox) {
        const selectionID = $modalCompetences.data("competences-selection-id");
        const $btn = $main.find(
            `form button[data-competences-selection="${selectionID || "xxxxxxx"}"]`
        );
        const htmlSelection = $btn.data("competences-selection-html");
        if (!selectionID || !$btn.length || !htmlSelection) return;
        $checkbox.closest(".modalC_check").addClass("is-checked");
        const compTitle = $checkbox.closest(".modalC_check").text();
        const compCat = $checkbox
            .closest(".modalC_theme")
            .find(".modalC_title")
            .text();
        const compID = $checkbox.val();
        if (
            $btn
                .closest(".formTable")
                .find(
                    '.formTable_r .formTable_c:first-child input[value="' + compID + '"]'
                ).length
        )
            return;
        $btn
            .closest(".formTable_caption")
            .before(
                htmlSelection
                    .replaceAll("%%title%%", compCat + " : " + compTitle)
                    .replaceAll("%%id%%", compID)
            );
        competences_update_numerotation($btn);
        form_local_save_datas($btn.closest(".formTable"));
    }

    function trigger_competences_uncheck($checkbox) {
        const selectionID = $modalCompetences.data("competences-selection-id");
        const $btn = $main.find(
            `form button[data-competences-selection="${selectionID || "xxxxxxx"}"]`
        );
        if (!selectionID || !$btn.length) return;
        $checkbox.closest(".modalC_check").removeClass("is-checked");
        const compID = $checkbox.val();
        $btn
            .closest(".formTable")
            .find(
                '.formTable_r .formTable_c:first-child input[value="' + compID + '"]'
            )
            .closest(".formTable_r")
            .remove();
        competences_update_numerotation($btn);
        form_local_save_datas($btn.closest(".formTable"));
    }

    function competences_update_numerotation($btn) {
        $btn
            .closest(".formTable")
            .find(".formTable_r")
            .each(function (idx, row) {
                const $row = $(row);
                $row.find('input[name$="]"]').each(function (k, input) {
                    input.name = input.name.replace(/\[[0-9]*\]/g, `[${idx}]`);
                });
            });
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // Form Grille d’entretien paritaire : modale fonctionnement global
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function modal_open($modal) {
        $modal.removeClass("is-hide");
        $modal.get(0).scrollTo(0, 0);
        if (!$html.hasClass("is-scrollBlockedAll")) {
            sauvScroll = scrollT;
            w.scrollTo(0, 0);
            idMenuMobileTimeOut = w.setTimeout(function () {
                $html.addClass("is-scrollBlockedAll");
            }, 300);
        }
        $html.addClass("has-modalOpen");
        // console.log($modal.data('competences-selection-id'));
    }

    $body.on("click", ".modal_close", function (event) {
        event.preventDefault();
        modal_close();
    });
    function modal_close() {
        if (idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
        $html.removeClass("is-scrollBlockedAll");
        w.scrollTo(0, sauvScroll);
        w.setTimeout(function () {
            $html.removeClass("has-modalOpen");
            $body.find(".modal:not(.is-hide)").addClass("is-hide");
        }, 50);
    }

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // Form Grille d’entretien paritaire : fonctionnement
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    // historique
    function form_local_historique() {
        const $historiqueCont = $main.find(".formGrilleHist_list");
        const $linkNewForm = $main.find(".js-form-grille-start:not([data-id])");
        const forms = localStorage.getItem("alisfa_local_forms")
            ? JSON.parse(localStorage.getItem("alisfa_local_forms"))
            : [];
        if (!$historiqueCont.length || !forms.length) {
            return;
        }
        const formsWithDatas = [];
        forms.forEach(function (formID) {
            if (localStorage.getItem("alisfa_local_form_" + formID)) {
                const formsDatas = JSON.parse(
                    localStorage.getItem("alisfa_local_form_" + formID)
                );
                formsWithDatas.push({
                    formID: formID,
                    datas: formsDatas,
                    date: formsDatas.date_update
                        ? new Date(formsDatas.date_update)
                        : false,
                });
            }
        });
        formsWithDatas
            .sort(function (a, b) {
                return b.date - a.date;
            })
            .forEach(function (form) {
                let noms = [];
                if (form.datas.fields.prenom) {
                    noms.push(form.datas.fields.prenom);
                }
                if (form.datas.fields.nom) {
                    noms.push(form.datas.fields.nom);
                }
                $historiqueCont.append(
                    '<li class="formGrilleHist_r"><span class="formGrilleHist_c"><span class="txt-700 txt-s">' +
                    (noms.length ? noms.join(" ") : "(Nom manquant)") +
                    "</span>" +
                    (form.date
                        ? ' <br><span class="f1-14 c-grey">Mis à jour le ' +
                        form.date.toJSON().slice(0, 10).split("-").reverse().join("/") +
                        "</span>"
                        : "") +
                    '</span><span class="formGrilleHist_c">' +
                    (list_emplois && list_emplois[form.datas.fields.emploi_repere]
                        ? list_emplois[form.datas.fields.emploi_repere]
                        : "(Emploi repère manquant)") +
                    '</span><a href="' +
                    $linkNewForm.attr("href").split("?")[0] +
                    "?form=" +
                    form.formID +
                    '" class="formGrilleHist_c btn">Consulter/modifier</a></li>'
                );
            });
        if ($historiqueCont.find(".formGrilleHist_r").length) {
            $historiqueCont.closest(".formGrilleHist").removeClass("is-hide");
        }
    }
    form_local_historique();

    // création d'un nouveau formulaire (id, ajout à la liste des forms, etc.)
    // $main.on('click', '.js-form-grille-start', function (event) {
    //     event.preventDefault();
    //     const btn = this;
    //     const $btn = $(this);
    //     const formID = btn.hasAttribute('data-id') ? btn.getAttribute('data-id') : 'id' + (new Date()).getTime(); //ou Math.random().toString(16).slice(2);
    //     // const forms = localStorage.getItem('alisfa_local_forms') ? JSON.parse(localStorage.getItem('alisfa_local_forms')) : [];
    //     // const formsDatas = {
    //     //     fields: {},
    //     //     steps: {}
    //     // };
    //     // if (!forms.includes(formID)) {
    //     //     forms.push(formID);
    //     // }
    //     // localStorage.setItem('alisfa_local_forms', JSON.stringify(forms));
    //     // Cookies.set("alisfa_current_local_form", formID, { expires: 365 });
    //     // if (btn.hasAttribute('data-emploi')) {
    //     //     Cookies.set("alisfa_current_local_form_emploi", btn.getAttribute('data-emploi'), { expires: 365 });
    //     // } else {
    //     //     Cookies.remove('alisfa_current_local_form_emploi');
    //     // }
    //     // if (!localStorage.getItem('alisfa_local_form_' + formID)) {
    //     //     localStorage.setItem('alisfa_local_form_' + formID, JSON.stringify(formsDatas));
    //     // }
    //     // window.location.href = $btn.attr('href');
    // });

    function form_local_get_id() {
        var params = new URLSearchParams(window.location.search);
        var formValue = params.get("form");
        return formValue ? formValue : false;
    }

    function form_local_init() {
        const $form = $main.find(".form-local");
        const formID = form_local_get_id();
        if (!formID || !$form.length) return;
        const forms = localStorage.getItem("alisfa_local_forms")
            ? JSON.parse(localStorage.getItem("alisfa_local_forms"))
            : [];
        const formsDatas = {
            fields: {},
            steps: {},
            date_creation: new Date().toISOString(),
            date_update: new Date().toISOString(),
        };

        if (forms.includes(formID)) return;
        forms.push(formID);
        localStorage.setItem("alisfa_local_forms", JSON.stringify(forms));
        localStorage.setItem(
            "alisfa_local_form_" + formID,
            JSON.stringify(formsDatas)
        );
    }
    form_local_init();

    // save datas on change
    function form_local_save_datas_on_change() {
        const $form = $main.find(".form-local");
        if (!$form.length) return;
        $form.on(
            "input",
            'input[name]:not([disabled]):not([type="radio"]):not([type="checkbox"]):not([name="form_action"]):not([name="generate_pdf"]), textarea[name]:not([disabled])',
            function (event) {
                form_local_save_datas($(this).parent());
            }
        );
        $form.on(
            "change",
            'input[type="radio"][name]:not([disabled]), input[type="checkbox"][name]:not([disabled]), select[name]:not([disabled])',
            function (event) {
                form_local_save_datas($(this).parent());
            }
        );
    }
    form_local_save_datas_on_change();

    // fonction pour enregistré les valeurs des champs en local
    // elle est utilisée à la fin d'un submit (cf. form_validation_submit)
    let isLocalFormDatasLoaded = false;
    function form_local_save_datas($cont) {
        if (
            !isLocalFormDatasLoaded ||
            (!$cont.length &&
                !$cont.is(".form-local") &&
                !$cont.closest(".form-local").lenght)
        )
            return;
        // const formID = Cookies.get("alisfa_current_local_form");
        const $form = $cont.is(".form-local")
            ? $cont
            : $cont.closest(".form-local");
        const formID = form_local_get_id();
        if (!formID) return;
        const formsDatas = localStorage.getItem("alisfa_local_form_" + formID)
            ? JSON.parse(localStorage.getItem("alisfa_local_form_" + formID))
            : {
                fields: {},
                steps: {},
                date_creation: new Date().toISOString(),
                date_update: new Date().toISOString(),
            };
        if (!formsDatas.date_creation) {
            formsDatas.date_creation = new Date().toISOString();
        }
        if (!formsDatas.date_update) {
            formsDatas.date_update = new Date().toISOString();
        }
        const oldEmploi = formsDatas.fields["emploi_repere"] || false;
        // préparation repeater
        $cont
            .find(".js-form-repeater-clone[data-repeater-id]")
            .each(function (idx, btn) {
                const repeaterID = $(btn).attr("data-repeater-id");
                formsDatas.fields[repeaterID] = {
                    nb_rows: $cont.find(
                        '.js-form-repeater[data-repeater-id="' + repeaterID + '"]'
                    ).length,
                };
            });
        // préparation competences
        $cont.find("button[data-competences-selection]").each(function (idx, btn) {
            const repeaterID = $(btn).attr("data-competences-selection");
            formsDatas.fields[repeaterID] = {
                list_ids: $(btn)
                    .closest(".formTable")
                    .find(".formTable_r .formTable_c:first-child input[value]")
                    .map(function () {
                        return $(this).val();
                    })
                    .get(),
            };
        });
        // récupération des données
        $cont
            .find(
                'input[name]:not([disabled]):not([name="form_action"]):not([name="generate_pdf"]), textarea[name]:not([disabled]), select[name]:not([disabled])'
            )
            .each(function (idx, input) {
                if (input.type === "radio" && !input.checked) {
                    return;
                }
                if ($(input).closest("[data-repeater-id]").length) {
                    // repeater
                    let repeaterID = $(input)
                        .closest("[data-repeater-id]")
                        .attr("data-repeater-id");
                    formsDatas.fields[repeaterID][input.name] = input.value;
                } else if (
                    $(input)
                        .closest(".formTable")
                        .find("button[data-competences-selection]").length
                ) {
                    // competences
                    let repeaterID = $(input)
                        .closest(".formTable")
                        .find("button[data-competences-selection]")
                        .attr("data-competences-selection");
                    formsDatas.fields[repeaterID][input.name] = input.value;
                } else {
                    // classique
                    formsDatas.fields[input.name] = input.value;
                }
            });
        // étape valide
        const step = $main.find(".pageNav_i.is-active").index();
        const stepValid = form_local_check_step_valid($form);
        formsDatas.steps["step_" + step] = stepValid || false;
        // changement emploi repère
        const newEmploi = formsDatas.fields["emploi_repere"] || false;
        if (oldEmploi !== newEmploi) {
            // Cookies.set("alisfa_current_local_form_emploi", newEmploi, { expires: 365 });
            Cookies.set("alisfa_local_form_emploi_" + formID, newEmploi, {
                expires: 365,
            });
            formsDatas.steps["step_" + 4] = false;
            for (const property in formsDatas.fields) {
                if (
                    property.indexOf("competence_base_") === 0 ||
                    property === "competences_dev_select" ||
                    property === "competences_n1_select"
                ) {
                    delete formsDatas.fields[property];
                }
            }
        }
        form_local_update_after_emploi_change(formsDatas);

        // enregistrement
        formsDatas.date_update = new Date().toISOString();
        localStorage.setItem(
            "alisfa_local_form_" + formID,
            JSON.stringify(formsDatas)
        );
    }

    // au chargement on récupère les donnée pour remplir les champs
    $main.find(".form-local").each(function (idx, el) {
        form_local_get_datas($(el));
        form_local_save_datas($(el));
    });

    function form_local_get_datas($form) {
        // const formID = Cookies.get("alisfa_current_local_form");
        const formID = form_local_get_id();
        if (!formID) return;
        const formsDatas = localStorage.getItem("alisfa_local_form_" + formID)
            ? JSON.parse(localStorage.getItem("alisfa_local_form_" + formID))
            : {
                fields: {},
                steps: {},
            };
        // affichage des row repeater
        $form
            .find(".js-form-repeater-clone[data-repeater-id]")
            .each(function (idx, btn) {
                const repeaterID = $(btn).attr("data-repeater-id");
                const nbRow =
                    formsDatas.fields[repeaterID] && formsDatas.fields[repeaterID].nb_rows
                        ? parseInt(formsDatas.fields[repeaterID].nb_rows)
                        : 0;
                if (nbRow) {
                    for (let index = 0; index < nbRow; index++) {
                        $(btn).trigger("click");
                    }
                }
            });
        // affichage des row compétences
        $form.find("button[data-competences-selection]").each(function (idx, btn) {
            const repeaterID = $(btn).attr("data-competences-selection");
            const list_ids =
                formsDatas.fields[repeaterID] && formsDatas.fields[repeaterID].list_ids
                    ? formsDatas.fields[repeaterID].list_ids
                    : [];
            if (!$modalCompetences.length) return;
            $modalCompetences.data("competences-selection-id", repeaterID);
            list_ids.forEach(function (cID) {
                $modalCompetences
                    .find('input[type="checkbox"][value="' + cID + '"]')
                    .prop("checked", true)
                    .trigger("change");
            });
        });
        // récupération des valeurs des champs
        $form
            .find(
                'input[name]:not([disabled]):not([name="form_action"]):not([name="generate_pdf"]), textarea[name]:not([disabled]), select[name]:not([disabled])'
            )
            .each(function (idx, input) {
                let val = null;
                if ($(input).closest("[data-repeater-id]").length) {
                    // repeater
                    let repeaterID = $(input)
                        .closest("[data-repeater-id]")
                        .attr("data-repeater-id");
                    if (
                        formsDatas.fields[repeaterID] &&
                        formsDatas.fields[repeaterID].hasOwnProperty(input.name)
                    ) {
                        val = formsDatas.fields[repeaterID][input.name];
                    }
                } else if (
                    $(input)
                        .closest(".formTable")
                        .find("button[data-competences-selection]").length
                ) {
                    // compétences
                    let repeaterID = $(input)
                        .closest(".formTable")
                        .find("button[data-competences-selection]")
                        .attr("data-competences-selection");
                    if (
                        formsDatas.fields[repeaterID] &&
                        formsDatas.fields[repeaterID].hasOwnProperty(input.name)
                    ) {
                        val = formsDatas.fields[repeaterID][input.name];
                    }
                } else if (formsDatas.fields.hasOwnProperty(input.name)) {
                    // classique
                    val = formsDatas.fields[input.name];
                }
                if (val !== null) {
                    if (input.type === "radio") {
                        if (input.value == val) {
                            input.checked = true;
                        }
                    } else {
                        input.value = val;
                    }
                }
            });
        // init fonctions formulaire
        form_cond_init($form);
        form_auto_sum_init($form);
        form_local_update_after_emploi_change(formsDatas);
        isLocalFormDatasLoaded = true;
    }

    function form_local_update_after_emploi_change(formsDatas) {
        // étapes valides
        $main.find(".pageNav_i").each(function (idx, el) {
            if (idx === 0 || formsDatas.steps["step_" + idx]) {
                $(el).addClass("is-success");
            } else {
                $(el).removeClass("is-success");
            }
        });
        // titre valide
        const step = $main.find(".pageNav_i.is-active").index();
        if (formsDatas.steps["step_" + step]) {
            $main.find(".espace_step").addClass("is-success");
        } else {
            $main.find(".espace_step").removeClass("is-success");
        }
        // bouton pdf
        $main
            .find(".js-form-grille-dl, .js-form-grille-dl-empty")
            .each(function (idx, btnform) {
                if (formsDatas.fields.emploi_repere) {
                    $(btnform)
                        .find('[type="submit"]')
                        .prop("disabled", false)
                        .next("p")
                        .hide();
                } else {
                    $(btnform)
                        .find('[type="submit"]')
                        .prop("disabled", true)
                        .next("p")
                        .show();
                }
            })
            .off("submit")
            .on("submit", function (event) {
                form_append_datas($(this), $(this).hasClass("js-form-grille-dl-empty"));
            });
    }

    function form_append_datas($form, empty) {
        // const formID = Cookies.get("alisfa_current_local_form");
        const formID = form_local_get_id();
        if (!formID) return;
        const formsDatas = localStorage.getItem("alisfa_local_form_" + formID)
            ? JSON.parse(localStorage.getItem("alisfa_local_form_" + formID))
            : {
                fields: {},
                steps: {},
            };
        if (!formsDatas.fields.emploi_repere) {
            return;
        }
        $form.find('input[name="all_datas"][value]').remove();
        if (!$form.find('input[name="generate_pdf"]').length) {
            $form.append(
                '<input type="hidden" name="generate_pdf" value="' +
                (empty ? "empty" : "1") +
                '">'
            );
        }
        let $hiddenInputDatas = $("<input>", {
            type: "hidden",
            name: "all_datas",
            value: JSON.stringify(
                empty
                    ? { emploi_repere: formsDatas.fields.emploi_repere }
                    : formsDatas.fields
            ),
        });
        $form.append($hiddenInputDatas);
    }

    function form_local_check_step_valid($form) {
        var valid = true;
        $form
            .find(".form_p input[name], .form_p textarea[name], .form_p select[name]")
            .each(function (idx, input) {
                const error = form_check_validity_input(input);
                valid = error || !valid ? false : true;
            });
        return valid;
    }
})(jQuery);
